export const en = {
  nav: {
    overview: "Overview",
    accounts: "Accounts",
    payouts: "Payouts",
    affiliate: "Affiliate",
    support: "Support"
  },
  dashboardheader: {
    serverTime: "Server Time",
    wallet: "Wallet",
    settings: "Settings",
    logout: "Logout",
    goToProfile: "Go to Profile"
  },
  protectedLayout: {
    connecting: {
      title: "Establishing Connection",
      authenticating: "Authenticating...",
      establishing: "Establishing connection..."
    },
    connectionLost: {
      title: "No Server Connection",
      description: "The connection has been interrupted. We are automatically attempting to restore the connection.",
      possibleCauses: "Possible Causes:",
      causes: {
        internet: "Your internet connection was interrupted",
        maintenance: "The server is currently undergoing maintenance",
        firewall: "Your firewall or proxy is blocking the connection",
        sleep: "Your device entered sleep mode"
      },
      reconnecting: "Reconnecting...",
      attempt: "Attempt",
      waiting: "Waiting for connection...",
      reloadButton: "Reload Page Manually"
    },
    connectionRestored: {
      title: "Connection Restored",
      message: "Connected to server"
    }
  },
  accountCards: {
    title: "Trading Accounts",
    addAccount: "Add Account",
    selectMultiple: "Select Multiple",
    cancelSelection: "Cancel",
    backToAccounts: "Back to Accounts",
    balance: "Balance",
    days: "Trading days",
    maxLots: "Max Lots",
    drawdown: "Drawdown",
    finalPnL: "Final P&L",
    current: "Current",
    target: "Target",
    evaluationFailed: "Evaluation Failed",
    evaluationPassed: "Evaluation Passed",
    evaluationPassedTitle: "Congratulations!",
    congratulationsSuccess: "You have successfully passed your evaluation",
    resetAccount: "Reset Account",
    extendAccount: "Extend Account",
    signFundedAgreement: "Activate your new Funded Account",
    awaitingFundedFee: "Awaiting Funded Fee",
    payFundedFee: "Pay Funded Fee",
    contractSigned: "Contract signed - payment required",
    livePnL: "Live P&L",
    today: "today",
    since: "Since: ",
    started: "Started: ",
    passed: "Passed: ",
    failed: "Failed: ",
    expired: "Expired: ",
    open: "Open",
    accountExpired: "Account Expired",
    timeExpired: "Time Expired",
    accountPeriodEnded: "The account period has ended",
    daysUntilClosure: "You have only {{days}} days left to extend the account, otherwise it will be closed.",
    deactivationReasons: {
      "Rule Violation": "Rule Violation"
    },
    ruleViolations: {
      "Max Drawdown exceeded": "Max Drawdown Exceeded",
      "Trading outside permitted hours": "Trading Outside Permitted Hours",
      "Traded more contracts than permitted": "Traded More Contracts Than Permitted"
    },
    expiryWarning: "Account Expiring Soon",
    expiresIn: "Account expires in {{days}} day(s)",
    noAccountsTitle: "No trading accounts yet",
    noAccountsDescription: "Get started by purchasing your first evaluation account and begin your journey to becoming a funded trader",
    fastSetup: "Fast Setup",
    instantAccess: "Instant Access",
    noHiddenFees: "No Hidden Fees",
    status: {
      active: "Active",
      inProgress: "Evaluation",
      passed: "Passed",
      failed: "Failed",
      expired: "Expired"
    },
    filters: {
      all: "All",
      funded: "Funded",
      evaluation: "Evaluation",
      active: "Active",
      inactive: "Inactive",
      resettable: "Resettable",
      expired: "Expired",
      noResults: "No accounts match this filter",
      showAll: "Show all accounts"
    }
  },
  accountInformation: {
    title: "Account Information",
    accountTimeline: "Account Timeline",
    accountSize: "Account Size",
    dataFeed: "Data Feed",
    loginCredentials: "Login Credentials",
    username: "Username",
    password: "Password",
    server: "Server",
    copy: "Copy",
    important: "Important",
    credentialsNote: "Use these credentials to log into your {dataFeed} platform. Keep them secure and do not share with anyone.",
    startDate: "Start Date",
    expiryDate: "Expiry Date",
    daysRemaining: "Days Remaining",
    days: "days",
    extend: "Extend",
    extendAccount: "Extend Account",
    resetBalance: "Reset",
    tradingSpecifications: "Trading Specifications",
    maxPositionSize: "Max Lots",
    profitTarget: "Profit Target",
    maxDrawdown: "Max Drawdown",
    tradingHours: "Trading Hours",
    accountPeriodEnded: "The account period has ended"
  },
  accountSelector: {
    title: "Account Analytics",
    analytics: "Live Analytics",
    description: "Real-time performance tracking",
    liveData: "Live Data",
    account: "Account",
    status: "Status"
  },
  performanceMetrics: {
    accountBalance: "Account Balance",
    netProfit: "Net Profit",
    todaysPnL: "Today's P&L",
    winRate: "Win Rate",
    tradingDays: "Trading Days",
    vsYesterday: "vs yesterday",
    trades: "Trades",
    totalExecuted: "Total executed",
    activeDays: "Active days",
    allTime: "All time"
  },
  performanceChart: {
    title: "Performance Chart",
    subtitle: "Account balance over time",
    balance: "Balance",
    pnl: "P&L",
    percentage: "Percentage",
    currentBalance: "Current Balance",
    drawdownLimit: "Drawdown Limit",
    profitFactor: "Profit Factor",
    avgWinLoss: "Avg Win/Loss",
    target: "Target",
    unlimited: "Unlimited",
    limit: "Limit",
    start: "Start",
    hoverForDetails: "Hover chart points for details"
  },
  pnlBreakdown: {
    title: "P&L Breakdown",
    subtitle: "Profit and loss analysis",
    bySymbol: "By Symbol",
    byTime: "By Time",
    grossProfit: "Gross Profit",
    grossLoss: "Gross Loss",
    netPnL: "Net P&L",
    byTradingSymbol: "By Trading Symbol",
    byTimeOfDay: "By Time of Day",
    noData: "No trading data available"
  },
  riskAnalysis: {
    title: "Risk Analysis",
    subtitle: "Account risk metrics"
  },
  tradeHistory: {
    title: "Trade History",
    tradesFound: "trades found",
    export: "Export",
    allTrades: "All Trades",
    winsOnly: "Wins Only",
    lossesOnly: "Losses Only",
    searchPlaceholder: "Search by symbol...",
    symbol: "Symbol",
    type: "Type",
    entry: "Entry",
    exit: "Exit",
    qty: "Qty",
    pnl: "P&L",
    duration: "Duration",
    entryDateTime: "Entry Date/Time",
    exitDateTime: "Exit Date/Time",
    showing: "Showing",
    of: "of",
    trades: "trades",
    previous: "Previous",
    next: "Next",
    winningTrades: "Winning Trades",
    losingTrades: "Losing Trades",
    totalPnL: "Total P&L",
    winRate: "Win Rate",
    noTradesFound: "No trades found"
  },
  tradingStatistics: {
    title: "Trading Statistics",
    subtitle: "Detailed performance metrics",
    winRate: "Win Rate",
    winningTrades: "Winning Trades",
    losingTrades: "Losing Trades",
    averagePerformance: "Average Performance",
    avgWin: "Avg Win",
    avgLoss: "Avg Loss",
    profitFactor: "Profit Factor",
    extremes: "Extremes",
    largestWin: "Largest Win",
    largestLoss: "Largest Loss",
    bestDay: "Best Day",
    worstDay: "Worst Day",
    streaks: "Streaks",
    maxWinningStreak: "Max Winning Streak",
    maxLosingStreak: "Max Losing Streak",
    avgTradeDuration: "Avg Trade Duration",
    trades: "trades"
  },
  affiliate: {
    title: "Affiliate Program",
    referralSystem: "Referral System",
    earnCommissions: "Earn commissions by referring traders",
    tier: "Tier",
    silver: "Silver",
    gold: "Gold",
    bonus: "Bonus",
    handleChangedToast: "Your affiliate handle has been changed. Your referral links have been updated automatically. Please check if any previously shared marketing links need to be replaced.",
    errorTitle: "Unable to Load Affiliate Data",
    errorSubtitle: "Something went wrong",
    errorDescription: "We could not load your affiliate information. This can happen if your affiliate account has not been set up yet or if there was a temporary connection issue.",
    retry: "Try Again",
    backToDashboard: "Back to Dashboard",
    createAffiliate: "Create Affiliate",
    creating: "Creating...",
    enrollFailed: "Failed to create affiliate account. Please try again."
  },
  affiliateOverview: {
    totalEarnings: "Total Earnings",
    activeReferrals: "Active Referrals",
    conversionRate: "Conversion Rate",
    totalCommissions: "Total Commissions",
    commissionRate: "Commission Rate",
    thisMonth: "this month",
    standard: "Standard",
    onAllSales: "on all sales",
    vsLastMonth: "vs last month"
  },
  affiliateTier: {
    tier: "Tier",
    progressTo: "Progress to",
    currentAffiliate: "Current Affiliate Tier",
    currentBenefits: "Current Benefits",
    progressToTier: "Progress to Tier",
    current: "Current",
    allAffiliateTiers: "All Affiliate Tiers",
    revenue: "revenue",
    nextTierUnlock: "Next tier unlock",
    moreRevenueNeeded: "more revenue needed",
    achieved: "Achieved"
  },
  affiliateStatistics: {
    title: "Affiliate Statistics",
    weeklyEarningsOverview: "Weekly earnings overview",
    day: "Day",
    week: "Week",
    month: "Month",
    year: "Year",
    currentMonth: "Current Month",
    currentQuarter: "Current Quarter",
    currentYear: "Current Year",
    last5Years: "Last 5 Years",
    previousMonth: "Previous Month",
    previousQuarter: "Previous Quarter",
    previousYear: "Previous Year",
    nextMonth: "Next Month",
    nextQuarter: "Next Quarter",
    nextYear: "Next Year",
    monthsAgo: "months ago",
    monthsAhead: "months ahead",
    quartersAgo: "quarters ago",
    quartersAhead: "quarters ahead",
    yearsAgo: "years ago",
    yearsAhead: "years ahead",
    totalEarningsLabel: "Total Earnings",
    lastWeeks: "last 12 weeks",
    bestDayLabel: "Best Day",
    bestWeekLabel: "Best Week",
    bestMonthLabel: "Best Month",
    bestYearLabel: "Best Year",
    bestWeek: "Best week",
    noData: "No data",
    referrals: "referrals",
    avg: "avg",
    hoverForDetails: "Hover chart points for details"
  },
  commissionTracking: {
    title: "Commission Tracking",
    found: "commissions found",
    all: "All",
    paid: "Paid",
    pending: "Pending",
    posted: "Posted",
    canceled: "Canceled",
    searchPlaceholder: "Search commissions...",
    commissionId: "Commission ID",
    customer: "Customer",
    plan: "Plan",
    commission: "Commission",
    status: "Status",
    source: "Source",
    purchaseDate: "Purchase Date",
    paidDate: "Paid Date",
    rate: "rate",
    showing: "Showing",
    of: "of",
    commissions: "commissions",
    previous: "Previous",
    next: "Next",
    totalCommission: "Total Commission",
    avgCommission: "Avg Commission",
    onHoldUntil: "On Hold until",
    postedAt: "Posted at",
    canceledAt: "Canceled at",
    reason: "Reason",
    sourceDetails: "Source Details",
    category: "Category",
    code: "Code",
    path: "Path",
    noCommissions: "No commissions found",
    noCommissionsDescription: "There are no commission records matching your filters"
  },
  earningsOverview: {
    title: "Earnings Overview",
    subtitle: "Your affiliate performance",
    month: "Month",
    quarter: "Quarter",
    year: "Year",
    totalEarnings: "Total Earnings",
    pending: "Of which pending",
    performanceMetrics: "Performance Metrics",
    conversionRate: "Conversion Rate",
    avgCommission: "Avg Commission",
    transactions: "Transactions",
    totalClicks: "Total Clicks",
    totalConversions: "Total Conversions",
    monthlyProgress: "Monthly Progress",
    quarterlyProgress: "Quarterly Progress",
    yearlyProgress: "Yearly Progress",
    allTimeProgress: "All-Time Progress",
    goalProgress: "Goal Progress",
    goal: "Goal",
    all: "All"
  },
  marketingMaterials: {
    title: "Marketing Materials",
    subtitle: "Professional assets for promotion",
    banners: "Banners",
    content: "Content",
    logos: "Logos",
    availableAssets: "Available Assets",
    quality: "Quality",
    preview: "Preview"
  },
  partnerLandingPage: {
    title: "Partner Landing Page",
    subtitle: "Your custom referral page",
    landingPageUrl: "Landing Page URL",
    copyLink: "Copy Link",
    partnerName: "Partner Name",
    editText: "Edit Text",
    enterPartnerName: "Enter partner name",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    landingPageStats: "Landing Page Stats",
    totalVisits: "Total Visits",
    conversions: "Conversions",
    conversionRate: "Conversion Rate",
    revenue: "Revenue",
    commission: "Commission"
  },
  payoutReports: {
    title: "Payout Reports",
    subtitle: "Monthly commission reports & wallet payouts",
    all: "All",
    paid: "Paid",
    pending: "Pending",
    completed: "Completed",
    rejected: "Rejected",
    canceled: "Canceled",
    totalPaid: "Total Paid",
    totalReferrals: "Total Referrals",
    reports: "Reports",
    referrals: "referrals",
    paidToWallet: "Paid to Wallet",
    paidOn: "Paid on",
    pendingTooltip: "Will be paid at the end of the month",
    walletPendingTooltip: "Payout request is being processed",
    walletCompletedTooltip: "Payout has been completed",
    walletRejectedTooltip: "Payout was rejected",
    walletCanceledTooltip: "Payout was canceled",
    rejectionReason: "Reason",
    walletPayout: "Affiliate Wallet Payout",
    settlementReport: "Commission Settlement",
    noReceiptAvailable: "No receipt available for this payout",
    showing: "Showing",
    of: "of",
    nextPayout: "Next Payout",
    exportAllReports: "Export All Reports",
    noFileAvailable: "No file available for this settlement",
    downloadFailed: "Download failed. Please try again.",
    noReports: "No payout reports available yet",
    adjustFilters: "Try adjusting your filters"
  },
  referralLinks: {
    title: "Referral Links & Codes",
    subtitle: "Manage your referral links and codes",
    tabLinks: "Links",
    tabCodes: "Codes",
    createCustomReferralLink: "Create Custom Referral Link",
    createCustomReferralCode: "Create Custom Referral Code",
    linkName: "Link Name",
    codeName: "Code Name",
    linkNamePlaceholder: "e.g., YouTube Special",
    codeNamePlaceholder: "e.g., YOUTUBE2025",
    description: "Description",
    descriptionPlaceholder: "e.g., Special link for YouTube content",
    codeDescriptionPlaceholder: "e.g., Special code for YouTube viewers",
    category: "Category",
    categoryPlaceholder: "e.g., YouTube, Instagram, etc.",
    customSlug: "Custom Slug (Optional)",
    customSlugPlaceholder: "your-url",
    customCode: "Custom Code",
    customCodePlaceholder: "MYCODE2025",
    leaveEmptyNote: "Leave empty to auto-generate",
    leaveEmptyCodeNote: "Leave empty to auto-generate code",
    cancel: "Cancel",
    createLink: "Create Link",
    createCode: "Create Code",
    clicks: "Clicks",
    uses: "Uses",
    conversions: "Conversions",
    rate: "Rate",
    showing: "Showing",
    of: "of",
    links: "links",
    codes: "codes",
    previous: "Previous",
    next: "Next",
    page: "Page",
    createCustomLink: "Create Custom Link",
    createCustomCode: "Create Custom Code",
    noLinks: "No referral links yet",
    noCodes: "No referral codes yet",
    defaultCodeName: "Standard",
    defaultCodeCategory: "Global",
    defaultCodeDescription: "System generated code with 10% discount"
  },
  trafficSources: {
    title: "Traffic Sources",
    subtitle: "Where your traffic comes from",
    clicks: "clicks",
    rate: "rate",
    uses: "uses",
    transactions: "transactions",
    noLinksYet: "No link traffic sources available yet",
    noCodesYet: "No code traffic sources available yet",
    showing: "Showing",
    of: "of",
    sources: "sources",
    previous: "Previous",
    next: "Next",
    summary: "Summary",
    totalClicks: "Total Clicks",
    totalUses: "Total Uses",
    conversions: "Conversions",
    totalCommission: "Total Commission",
    avgRate: "Avg Rate"
  },
  walletModal: {
    title: "Wallet",
    subtitle: "Manage your funds",
    overview: "Overview",
    transactions: "Transactions"
  },
  walletBalance: {
    title: "Wallet Balance",
    available: "Available funds",
    today: "today"
  },
  balanceBreakdown: {
    title: "Balance Breakdown",
    affiliateCommissions: "Affiliate Commissions",
    affiliateDesc: "Earnings from referrals",
    rewards: "Rewards",
    rewardsDesc: "Bonus earnings",
    crediting: "Crediting",
    creditingDesc: "Account credits",
    processing: "Processing...",
    payout: "Payout",
    creditsNote: "Credits and rewards are automatically added to your balance and can be used for all purchases but cannot be paid out."
  },
  transactionHistory: {
    title: "Transaction History",
    recentActivity: "Recent Activity",
    viewAll: "View All",
    showing: "Showing",
    of: "of",
    transactions: "transactions"
  },
  payoutTab: {
    availableForPayout: "Available for Payout",
    affiliateCommissionBalance: "Affiliate Commission Balance",
    bankTransfer: "Bank Transfer",
    paypal: "PayPal",
    cryptocurrency: "Cryptocurrency",
    requestAffiliatePayout: "Request Affiliate Payout",
    withdrawCommissionEarnings: "Withdraw your commission earnings",
    selectPaymentMethod: "Select Payment Method",
    payoutSummary: "Payout Summary",
    requestedAmount: "Requested Amount",
    processingFee: "Processing Fee",
    netAmount: "Net Amount",
    processingRequest: "Processing Request...",
    importantNotes: "Important Notes",
    note1: "Affiliate payouts are processed within 1-2 business days",
    note2: "Minimum payout amount is €50 for all payment methods",
    note3: "Processing fees vary by payment method",
    payoutRequestSubmitted: "Payout Request Submitted!",
    payoutRequestSuccess: "Your payout request for ${amount} has been submitted successfully.",
    affiliateCommissions: "Affiliate Commissions",
    readyForWithdrawal: "Ready for withdrawal",
    bankTransferDesc: "Direct transfer to your bank account",
    free: "Free",
    paypalDesc: "Fast payout via PayPal",
    cryptocurrencyDesc: "Payout via cryptocurrency",
    account: "Account",
    amount: "Amount",
    method: "Method",
    destination: "Destination",
    processingTime: "Processing Time",
    businessDays: "1-3 business days",
    fee: "Fee",
    managePayouts: "Manage Methods"
  },
  payouts: {
    title: "Payouts",
    management: "Payout Management",
    description: "Request and track your payouts",
    available: "Available"
  },
  payoutStats: {
    availableBalance: "Available Balance",
    totalPaidOut: "Total Paid Out",
    thisMonth: "This Month",
    nextPayout: "Next Payout",
    pendingPayouts: "Pending Payouts",
    pending: "Pending",
    today: "Today",
    payouts: "payouts",
    allTime: "All Time",
    january2025: "January 2025",
    tomorrow: "Tomorrow",
    dailySchedule: "Daily Schedule",
    automatic: "Automatic"
  },
  payoutRequest: {
    title: "Request Payout",
    subtitle: "Withdraw your trading profits",
    selectAccount: "Select Account",
    availableBalance: "Available Balance",
    payoutAmount: "Payout Amount",
    minAmount: "Min amount",
    amountError: "Amount must be between {min} and {max}",
    insufficientBalance: "Your available balance is below the minimum payout amount of {min}",
    selectAccountFirst: "Please select an account first",
    paymentMethod: "Payment Method",
    selectYour: "Select your",
    bankTransfer: "Bank Transfer",
    paypal: "PayPal",
    crypto: "Cryptocurrency",
    ach: "ACH Transfer",
    bankTransferDesc: "Bank transfer (1-3 business days)",
    paypalDesc: "PayPal transfer (instant)",
    cryptoDesc: "Cryptocurrency transfer (instant)",
    achDesc: "Bank transfer via ACH (1-3 business days)",
    fee: "Fee",
    free: "Free",
    payoutSummary: "Payout Summary",
    requestedAmount: "Requested Amount",
    processingFee: "Processing Fee",
    netAmount: "Net Amount",
    submitRequest: "Submit Payout Request",
    processing: "Processing...",
    importantNotes: "Important Notes",
    note1: "Payouts are processed within 1-3 business days",
    note2: "Minimum payout amount is $50",
    note3: "You can only request payouts from funded accounts",
    available: "Available",
    payoutRequestSubmitted: "Payout Request Submitted!",
    payoutRequestSuccess: "Your payout request for ${amount} has been submitted successfully.",
    account: "Account",
    amount: "Amount",
    method: "Method",
    destination: "Destination",
    processingTime: "Processing Time",
    businessDays: "1-3 business days",
    noFundedAccountsTitle: "No Funded Accounts Available",
    noFundedAccountsDesc: "You don't have any funded accounts with available balance for payout at the moment.",
    noAffiliateBalanceTitle: "No Affiliate Balance Available",
    noAffiliateBalanceDesc: "You don't have any affiliate commission balance available for payout at the moment.",
    selectCurrency: "Select Currency",
    currency: "Currency",
    noMethodsConfigured: "No {method} methods configured. Please add one in Payment Methods.",
    kycNotVerifiedTitle: "KYC Verification Required",
    kycNotVerifiedDesc: "Your identity has not been verified yet. Please complete the KYC verification to be able to request a payout.",
    verifyKycNow: "Verify Identity Now"
  },
  payoutEligibility: {
    title: "Payout Eligibility",
    loading: "Checking payout eligibility...",
    error: "Could not check eligibility. Please try again later.",
    eligible: "You are eligible for a payout",
    notEligible: "You are not eligible for a payout yet",
    rules: "Rules",
    passed: "passed",
    checkPassed: "Passed",
    checkFailed: "Failed",
    required: "Required",
    actual: "Actual",
    maxPayout: "Max Payout Amount",
  },
  payoutMethods: {
    title: "Payout Methods",
    subtitle: "Manage your payment methods",
    add: "Add Method",
    paypal: "PayPal",
    default: "Default",
    setDefault: "Set Default",
    addPaymentMethod: "Add Payment Method",
    bankTransfer: "Bank Transfer",
    bankTransferDesc: "Direct bank transfer",
    paypalDesc: "PayPal payments",
    crypto: "Cryptocurrency",
    cryptoDesc: "Crypto payments",
    ach: "ACH Transfer",
    achDesc: "Direct bank transfer via ACH",
    accountHolder: "Account Holder",
    iban: "IBAN",
    bicSwift: "BIC/SWIFT",
    bankName: "Bank Name",
    routingNumber: "Routing Number",
    accountNumber: "Account Number",
    enterRoutingNumber: "Enter routing number",
    enterAccountNumber: "Enter account number",
    paypalEmail: "PayPal Email",
    walletAddress: "Wallet Address",
    currencyType: "Currency Type",
    accountCurrency: "Account Currency",
    paypalCurrency: "PayPal Currency",
    enterAccountHolder: "Enter account holder name",
    enterIban: "Enter IBAN",
    enterBicSwift: "Enter BIC/SWIFT code",
    enterBankName: "Enter bank name",
    enterPaypalEmail: "Enter PayPal email",
    enterWalletAddress: "Enter wallet address",
    enterCurrencyType: "Enter currency type",
    cancel: "Cancel",
    saveMethod: "Save Method",
    secureEncrypted: "Secure & Encrypted",
    securityNote: "All payment information is encrypted and stored securely. We never store sensitive payment details."
  },
  payoutHistory: {
    title: "Payout History",
    payoutsFound: "payouts found",
    export: "Export",
    allPayouts: "All Payouts",
    completed: "Completed",
    processing: "Processing",
    failed: "Failed",
    searchPlaceholder: "Search payouts...",
    payoutId: "Payout ID",
    amount: "Amount",
    method: "Method",
    status: "Status",
    requestDateTime: "Request Date/Time",
    completedDateTime: "Completed Date/Time",
    account: "Account",
    reference: "Reference",
    action: "Action",
    fee: "Fee",
    net: "Net",
    pending: "Pending",
    cancelPayout: "Cancel Payout",
    showing: "Showing",
    of: "of",
    payouts: "payouts",
    previous: "Previous",
    next: "Next",
    totalNet: "Total Net",
    statusPending: "Pending",
    statusCanceled: "Canceled",
    statusCompleted: "Completed",
    canceledByUser: "Canceled by user",
    noReasonProvided: "No reason provided",
    noPayoutsFound: "No payouts found",
    noPayoutsMessage: "There are no payout records matching your filters",
    loading: "Loading payouts...",
    pleaseWait: "Please wait..."
  },
  support: {
    title: "Support Center",
    subtitle: "We're here to help you succeed",
    premiumSupport: "Premium Support",
    helpAndFaq: "Help & FAQ",
    helpAndSupport: "Help & Support",
    getHelpWhenNeeded: "Get help when you need it",
    available247: "Available 24/7",
    maintenanceTitle: "Support Area Under Construction",
    maintenanceMessage: "We are currently activating and finalizing the new support area. In the meantime, please send all your questions to:",
    maintenanceEmail: "support@nextproptrader.com",
    contactUs: "Contact Us",
    emailDescription: "Send us an email and our support team will get back to you as soon as possible.",
    clickToEmail: "Click to send email",
    responseTime: "Typical response within 24 hours"
  },
  supportStats: {
    responseTime: "Response Time",
    resolutionRate: "Resolution Rate",
    activeTickets: "Active Tickets",
    satisfaction: "Satisfaction",
    average: "Average",
    businessHours: "business hours",
    firstContact: "First contact",
    resolution: "resolution",
    vsYesterday: "vs yesterday",
    thisMonth: "this month"
  },
  supportTickets: {
    title: "Support Tickets",
    subtitle: "Track and manage your tickets",
    loading: "Loading tickets...",
    ticketsFound: "tickets found",
    noTicketsFound: "No tickets found",
    adjustFilters: "Try adjusting your filters or search term",
    createdLabel: "Created:",
    updatedLabel: "Updated:",
    all: "All",
    open: "Open",
    closed: "Closed",
    resolved: "Resolved",
    status_open: "OPEN",
    status_pending: "PENDING",
    status_in_progress: "IN PROGRESS",
    status_resolved: "RESOLVED",
    status_closed: "CLOSED",
    priority_low: "LOW",
    priority_medium: "MEDIUM",
    priority_high: "HIGH",
    priority_urgent: "URGENT",
    searchPlaceholder: "Search tickets...",
    ticketId: "Ticket ID",
    subject: "Subject",
    status: "Status",
    priority: "Priority",
    created: "Created",
    assignedTo: "Assigned To",
    ticketDetails: "Ticket Details",
    category: "Category",
    lastUpdate: "Last Update",
    conversation: "Conversation",
    messages: "messages",
    typeMessage: "Type your message...",
    sendMessage: "Send Message",
    sending: "Sending...",
    ticketResolved: "This ticket has been resolved",
    noMoreMessages: "No more messages can be sent",
    closingTicket: "Closing Ticket...",
    closeTicket: "Close Ticket",
    showing: "Showing",
    of: "of",
    tickets: "tickets",
    previous: "Previous",
    next: "Next",
    noMessages: "No messages yet",
    you: "You",
    supportTeam: "Support Team",
    attachment: "Attachment",
    attachFile: "Attach file",
    attachments: "Attachments",
    uploading: "Uploading...",
    uploadFailed: "Upload failed",
    uploadingAttachments: "Uploading attachments...",
    fileTooLarge: "File too large (max 10 MB)",
    invalidFileType: "Invalid file type",
    allowedTypes: "Allowed: jpg, png, gif, pdf, doc, docx, txt, zip, rar",
    downloadAttachment: "Download",
    removeAttachment: "Remove"
  },
  knowledgeBase: {
    title: "Knowledge Base",
    subtitle: "Find answers quickly",
    searchPlaceholder: "Search articles...",
    allArticles: "All Articles",
    gettingStarted: "Getting Started",
    platformGuide: "Platform Guide",
    evaluationProcess: "Evaluation Process",
    payoutsBilling: "Payouts & Billing",
    troubleshooting: "Troubleshooting",
    popular: "POPULAR",
    readTime: "read",
    views: "views",
    updatedLabel: "Updated:",
    noArticlesFound: "No articles found",
    adjustSearch: "Try adjusting your search term or category",
    articlesFound: "articles found",
    viewAll: "View All"
  },
  liveChat: {
    title: "Support",
    subtitle: "Create a ticket",
    available247: "Available 24/7",
    initialBotMessage: "Hello! I'm here to help you with any questions or issues you might have. How can I assist you today?",
    supportAvailable: "Support Available",
    averageResponse: "Average response: < 2 hours",
    newTicket: "New Ticket",
    quickHelpTopics: "Quick Help Topics",
    accountLoginIssues: "Account & Login Issues",
    platformTechnicalSupport: "Platform & Technical Support",
    payoutQuestions: "Payout Questions",
    evaluationProcessHelp: "Evaluation Process Help",
    priority: "priority",
    responseTimes: "Response Times",
    highPriorityText: "High Priority",
    mediumPriorityText: "Medium Priority",
    lowPriorityText: "Low Priority",
    supportTeam: "Support Team",
    available: "Available",
    ticketSubject: "Ticket Subject",
    describeIssue: "Describe your issue...",
    ticketCreated: "Ticket Created",
    closeTicket: "Close Ticket",
    ticketCreatedSuccess: "Thank you for contacting support! Your ticket has been created with ID: {{ticketId}}. Our team will review your request and respond within a few hours during business hours.",
    ticketCreationError: "Sorry, we encountered an error creating your ticket. Please try again or contact support directly.",
    responses: {
      concern: "I understand your concern. Let me look into this for you.",
      escalate: "Thank you for the additional information. I'll escalate this to our technical team.",
      question: "That's a great question! Let me provide you with the details.",
      noted: "I've noted this in your ticket. Our team will investigate further.",
      anything: "Is there anything else I can help you with regarding this issue?"
    },
    whatHappensNext: "What happens next?",
    whatHappensNextDescription: "Our support team will review your ticket and respond within the expected timeframe based on your priority level. You'll receive updates via email.",
    createAnotherTicket: "Create Another Ticket",
    ticketIdLabel: "Ticket ID",
    statusLabel: "Status",
    statusOpen: "OPEN",
    creatingTicket: "Creating ticket...",
    categoryLabel: "Category",
    categories: {
      general: "General",
      account: "Account",
      technical: "Technical",
      payout: "Payout",
      evaluation: "Evaluation"
    }
  },
  faqSection: {
    badge: "Frequently Asked Questions",
    title: "Everything You Need",
    titleHighlight: "to Know",
    subtitle: "Get answers to the most common questions about our prop-trading program.",
    questions: {
      q1: {
        question: "How does the 100% profit split work?",
        answer: "You keep 100% of the profits you earn on your funded account. We don't take a cut because our business model works differently: when you trade profitably, we replicate your trades in the background with larger position sizes. Your success is our success - that's why we're invested in your long-term performance, not in selling evaluations."
      },
      q2: {
        question: "What are the evaluation rules I need to follow?",
        answer: "There are 4 simple rules during evaluation: (1) You need a minimum of 5 trading days to pass - there's no maximum time limit. (2) Don't exceed the maximum lot size for your account. (3) Stay above the trailing drawdown limit. (4) Close all positions by 3:15 PM CST - trading resumes at 5:00 PM CST. The profit target is 6-8% depending on your account size."
      },
      q3: {
        question: "What is the Lucky Punch Rule and the Scaling Plan?",
        answer: "Once funded, there are only 2 rules. The Lucky Punch Rule: no single trade may account for more than 30% of your total P&L, ensuring consistent performance. The Scaling Plan: you start with 1 contract and unlock 1 additional contract for every $2,500 in profit. For example, after $2,500 profit you can trade 2 contracts, after $5,000 you unlock 3, and so on."
      },
      q4: {
        question: "How fast can I get funded and receive payouts?",
        answer: "You can pass the evaluation in as little as 5 trading days. Once passed, your funded account is typically activated within 24 hours on business days. Payouts can be requested daily - we offer bank transfer, PayPal, and cryptocurrency as payout methods. The minimum payout amount is $50, and processing takes 1-3 business days."
      },
      q5: {
        question: "What data feeds and platforms do you use?",
        answer: "We use data feeds from Rithmic and DXFeed, providing real-time Level 2 market data with sub-millisecond execution. All platforms that support a Rithmic or DXFeed connection are supported. All accounts include Non-Professional CME market data at no extra cost."
      },
      q6: {
        question: "What is a trailing drawdown and how does it work?",
        answer: "The trailing drawdown is a dynamic maximum loss limit that moves upward as your account reaches new highs. It protects against excessive risk. For example, if your account starts at $50,000 with a $2,500 trailing drawdown, your floor is $47,500. If your balance rises to $52,000, the floor moves up to $49,500. The drawdown always trails your highest balance."
      },
      q7: {
        question: "How many accounts can I trade at the same time?",
        answer: "There is no limit. You can trade as many accounts as you want simultaneously. Whether you prefer to manage one account or several at once, the choice is entirely yours."
      },
      q8: {
        question: "What happens if I fail or don't pass in time?",
        answer: "For evaluation accounts, you can reset your account for a fee and start fresh. You can also extend your account at any time to get more time. For funded accounts, if you violate the rules, you would need to pass a new evaluation to get funded again. Both evaluation and funded accounts can be extended at any time."
      },
      q9: {
        question: "Is there a funded fee for funded accounts?",
        answer: "Yes, once you have a funded account there is a monthly funded fee of 95 EUR. This fee covers all software and data costs, including real-time market data and technical infrastructure. The best part: the 95 EUR covers ALL your funded accounts combined — whether you have 1 or 10 accounts, you only pay 95 EUR per month. The fee is only due once you have successfully passed the evaluation."
      }
    },
    titleDashboard: "Frequently Asked Questions",
    subtitleDashboard: "Find answers to common questions",
    allCategories: "All Categories",
    general: "General",
    trading: "Trading",
    gettingStarted: "Getting Started",
    evaluation: "Evaluation",
    platform: "Platform",
    payouts: "Payouts",
    account: "Account",
    rules: "Rules",
    articlesFound: "articles found",
    searchPlaceholder: "Search articles...",
    howToStartEvaluation: "How do I start an evaluation?",
    howToStartEvaluationAnswer: "Choose your account size ($10K-$250K) on the pricing page and complete the purchase. Your evaluation account is set up automatically and you can start trading immediately. The minimum evaluation period is 5 trading days.",
    whatIsProfitTarget: "What is the profit target?",
    whatIsProfitTargetAnswer: "The profit target is 6-8% of your account size, depending on the tier you choose. For example, on a $50K account with a 6% target, you'd need to reach $3,000 in profit. There is no time limit - take as long as you need.",
    howLongEvaluation: "Is there a time limit for the evaluation?",
    howLongEvaluationAnswer: "There is no maximum time limit for completing your evaluation. You need a minimum of 5 trading days to pass. You can take as many days as you need to reach the profit target while following the rules.",
    howToRequestPayout: "How do I request a payout?",
    howToRequestPayoutAnswer: "Go to your Wallet in the dashboard and select the Payout tab. Choose your funded account, enter the amount (minimum $50), and select your preferred method: bank transfer, PayPal, or cryptocurrency. Payouts are processed within 1-3 business days.",
    whatIsTrailingDrawdown: "What is the trailing drawdown?",
    whatIsTrailingDrawdownAnswer: "The trailing drawdown is a dynamic loss limit that moves upward as your account reaches new balance highs. If your account peaks at $52,000 with a $2,500 drawdown, your floor is $49,500. It never moves back down. This ensures responsible risk management throughout your trading.",
    canIUseEA: "Can I use Expert Advisors (EAs) or automated strategies?",
    canIUseEAAnswer: "Yes, EAs and automated strategies are allowed on our platform. However, they must not use prohibited strategies such as arbitrage, hedging across multiple accounts, tick scalping, or any form of latency exploitation. Standard algorithmic strategies are welcome.",
    whatTradingHours: "What are the trading hours?",
    whatTradingHoursAnswer: "All positions must be closed by 3:15 PM CST at the latest. Trading resumes at 5:00 PM CST. This applies to both evaluation and funded accounts. Holding positions through the close is not allowed and may result in a rule violation.",
    howToChangePassword: "How do I change my password or security settings?",
    howToChangePasswordAnswer: "Navigate to your Profile page, then open the Settings tab. Under the Security section, you can change your password and enable two-factor authentication for additional account protection.",
    whatDataFeeds: "What data feeds and market data do you provide?",
    whatDataFeedsAnswer: "We use Rithmic and DXFeed as data providers. Every account includes real-time Level 2 market data and Non-Professional CME data at no additional cost. This ensures accurate pricing with sub-millisecond execution speeds.",
    howToExtendAccount: "Can I extend or reset my evaluation account?",
    howToExtendAccountAnswer: "Yes. You can extend your account for an additional 30 days or reset it to start fresh, both directly from your dashboard. You can also earn free resets and extensions through our achievement and leveling system.",
    whatIsLuckyPunch: "What is the Lucky Punch Rule?",
    whatIsLuckyPunchAnswer: "The Lucky Punch Rule means no single trade may exceed 30% of your total P&L on a funded account. For example, if your total profit is $5,000, no individual trade should have contributed more than $1,500. This ensures consistent performance rather than relying on a single lucky trade.",
    whatIsScalingPlan: "How does the Scaling Plan work?",
    whatIsScalingPlanAnswer: "You start with 1 contract on your funded account. For every $2,500 in cumulative profit, you unlock 1 additional contract. After $2,500 profit you can trade 2 contracts, after $5,000 profit you unlock 3 contracts, and so on. This ensures you scale your position size gradually as your account grows.",
    whatPayoutMethods: "What payout methods are available?",
    whatPayoutMethodsAnswer: "We offer bank transfer, PayPal, and cryptocurrency payouts. The minimum payout amount is $50. Processing takes 1-3 business days. You can request payouts daily from your dashboard wallet. There are no hidden fees.",
    whatAccountSizes: "What account sizes are available?",
    whatAccountSizesAnswer: "We offer evaluation accounts ranging from $10,000 to $250,000 in trading capital. Each account tier has its own profit target, maximum lot size, and trailing drawdown limit. All accounts include Level 2 market data, Non-Professional CME data feeds, and 24/7 support.",
    howManyAccounts: "How many accounts can I trade at the same time?",
    howManyAccountsAnswer: "There is no limit. You can trade as many accounts as you want simultaneously. Whether you prefer to manage one account or several at once, the choice is entirely yours.",
    whatIfIFail: "What happens if I fail or don't pass in time?",
    whatIfIFailAnswer: "For evaluation accounts, you can reset your account for a fee and start fresh. You can also extend your account at any time. For funded accounts, if you violate the rules, you would need to pass a new evaluation to get funded again. Both evaluation and funded accounts can be extended at any time.",
    priority: "Priority",
    highPriorityText: "High Priority",
    mediumPriorityText: "Medium Priority",
    lowPriorityText: "Low Priority",
    noResults: "No articles found",
    tryDifferentSearch: "Try a different search term or filter.",
    contactTitle: "Still have questions?",
    contactDescription: "Our team is here to help. Reach out and we'll get back to you as soon as possible.",
    contactButton: "Contact Us"
  },
  notifications: {
    title: "Notifications",
    unread: "unread",
    markAllRead: "Mark all read",
    noNotifications: "No Notifications",
    allCaughtUp: "You're all caught up!",
    lastUpdated: "Last updated",
    tradeClosedTitle: "Trade Closed Successfully",
    tradeClosedMessage: "Your NQ1! position was closed for +$285 profit",
    minutesAgo: "{minutes} minutes ago",
    payoutProcessedTitle: "Payout Processed",
    payoutProcessedMessage: "Your $2,450 payout has been sent to your bank account",
    hourAgo: "1 hour ago",
    achievementUnlockedTitle: "Achievement Unlocked!",
    achievementUnlockedMessage: "You've earned the 'Risk Master' achievement",
    hoursAgo: "{hours} hours ago",
    riskAlertTitle: "Risk Management Alert",
    riskAlertMessage: "Your account is approaching the daily drawdown limit",
    marketUpdateTitle: "Market Update",
    marketUpdateMessage: "High volatility expected during NFP release",
    dayAgo: "1 day ago",
    accountVerifiedTitle: "Account Verified",
    accountVerifiedMessage: "Your identity verification has been completed"
  },
  chatModal: {
    lastSeen: "Last seen",
    typeMessage: "Type a message...",
    viewProfile: "View Profile",
    blockUser: "Block User",
    reportUser: "Report User",
    deleteChat: "Delete Chat"
  },
  chatOverview: {
    title: "Messages",
    unread: "unread",
    blockUser: "Block User",
    reportUser: "Report User",
    delete: "Delete",
    noMessages: "No Messages",
    startConversation: "Start a conversation with other traders",
    viewAllConversations: "View All Conversations",
    totalConversations: "total conversations",
    lastUpdated: "Last updated"
  },
  fundedAgreement: {
    title: "Funded Agreement",
    legalDocument: "Legal Document",
    signToActivate: "Sign to activate your funded account",
    evaluationPassed: "Evaluation Passed",
    account: "Account",
    finalPnL: "Final P&L",
    evaluationResult: "Evaluation Result",
    passedDate: "Passed Date",
    completionDate: "Completion Date",
    fundedCapital: "Funded Capital",
    tradingCapital: "Trading Capital",
    agreementTerms: "Agreement Terms",
    pleaseReviewCarefully: "Please review carefully before signing",
    firstName: "First Name",
    lastName: "Last Name",
    address: "Address",
    city: "City",
    zipCode: "ZIP Code",
    country: "Country",
    emailAddress: "Email Address",
    addressPlaceholder: "Enter your street address",
    cityPlaceholder: "Enter your city",
    zipCodePlaceholder: "Enter your ZIP code",
    countryPlaceholder: "Select your country",
    digitalSignature: "Digital Signature",
    clear: "Clear",
    signHereWithMouseOrFinger: "Sign here with mouse or finger",
    pleaseSignAboveToExecute: "Please sign above to execute the agreement",
    signToActivateAccount: "Sign to activate your account",
    identificationDocument: "Identification Document",
    uploadNewDocument: "Upload New Document",
    useExistingDocument: "Use Existing Document",
    documentSecurity: "Document Security",
    documentSecurityDesc: "All documents are encrypted and stored securely in compliance with data protection regulations.",
    printedName: "Printed Name",
    printedNameDesc: "Type your full legal name in capital letters",
    printedNameNote: "This should match the name on your identification document",
    agreementCheckbox: "I have read and agree to all terms and conditions of this Funded Agreement",
    signAgreement: "Sign Agreement",
    signingAgreement: "Signing Agreement...",
    requirementsChecklist: "Requirements Checklist",
    personalDataComplete: "Personal data complete",
    agreementAcceptance: "Agreement acceptance",
    importantNotice: "Important Notice",
    noticeText1: "This is a legally binding agreement. Please read all terms carefully before signing.",
    noticeText2: "By signing this agreement, you acknowledge that you understand and accept all terms and conditions.",
    noticeText3: "Once signed, this agreement cannot be modified without mutual consent from both parties.",
    loadingContract: "Loading contract...",
    errorLoadingContract: "Error loading contract"
  },
  agreementSuccess: {
    title: "Agreement Signed Successfully!",
    description: "Your Funded Agreement for account #{accountId} has been signed and processed.",
    accountCreationInfo: "Your funded account is being prepared and will be available within 24 hours.",
    fundedFeeTitle: "Monthly Funded Fee",
    fundedFeeSubtitle: "Required for account activation",
    activeSubscription: "Active Subscription",
    activeSubscriptionDesc: "Your funded fee subscription is active until:",
    paymentRequired: "Payment Required",
    paymentRequiredDesc: "To activate your funded account, please pay the monthly funded fee of €95.",
    payFundedFee: "Pay Funded Fee (€95)",
    signedBy: "Signed By",
    signedOn: "Signed On",
    account: "Account",
    status: "Status",
    active: "Active",
    waitingForPayment: "Waiting for Payment",
    backToDashboard: "Back to Dashboard",
    loadingStatus: "Loading contract status...",
    accountActivating: "Account Activating",
    accountActivatingDesc: "Your funded account will be activated within a few seconds."
  },
  profile: {
    title: "Profile"
  },
  profileTabs: {
    activity: "Activity",
    achievements: "Achievements",
    connections: "Connections",
    documents: "Documents",
    settings: "Settings"
  },
  profileHeader: {
    publicProfile: "Public Profile",
    privateProfile: "Private Profile",
    trades: "Trades",
    tradingDays: "Trading Days",
    seasons: "Seasons",
    joined: "Joined",
    follow: "Follow",
    message: "Message",
    messagesDisabled: "Messages Disabled"
  },
  userHeader: {
    eliteTrader: "Elite Trader",
    higherProfitSplits: "Higher profit splits",
    prioritySupport: "Priority support",
    exclusiveFeatures: "Exclusive features",
    dayStreak: "Day Streak",
    day: "day",
    days: "days",
    tradingConsistency: "Trading consistency",
    currentStreak: "Current Streak",
    bestStreak: "Best Streak",
    started: "Started",
    lastTrade: "Last Trade",
    recentTradingDays: "Recent Trading Days",
    trades: "trades",
    keepTradingDaily: "Keep trading daily to maintain your streak!",
    amazingConsistency: "Amazing consistency! You're on fire!",
    greatMomentum: "Great momentum! Keep it up!",
    buildingHabits: "Building great trading habits!",
    keepItUp: "Keep it up! Every day counts!",
    noStreakTitle: "No Streak Yet",
    noStreakMessage: "Start trading to build up your streak! Every trading day counts towards your consistency.",
    level: "Level",
    progressTo: "Progress to",
    currentLevel: "Current Level",
    nextLevel: "Next Level Benefits",
    nextRank: "Next Rank",
    nextRankAt: "at Level",
    currentRank: "Current Rank",
    rankBenefits: "Rank Benefits",
    maxRankReached: "Maximum rank reached!",
    rewardCredits: "Credits",
    rewardDiscount: "One-Time Discount",
    rewardFreeReset: "Free Reset",
    rewardFreeExtension: "Free Extension",
    rewardTradingFee: "Trading Fee",
    rewardDrawdownReduction: "Drawdown Reduction",
    account: "Account",
    tier: "Status",
    accounts: "Accounts",
    funded: "Funded",
    evaluation: "Evaluation",
    inactive: "Inactive"
  },
  achievements: {
    title: "Achievements",
    subtitle: "Your trading milestones",
    completed: "completed",
    progress: "Progress",
    earned: "Earned",
    remaining: "Remaining",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    viewAll: "View All Achievements",
    achievementStatus: "Achievement status",
    loading: "Loading achievements...",
    locked: "Locked",
    noAchievements: "No Achievements Yet",
    noAchievementsDesc: "Start trading to unlock your first achievement and track your progress!",
    startTrading: "Begin your journey",
    rarity: {
      common: "Common",
      rare: "Rare",
      epic: "Epic",
      legendary: "Legendary",
      special: "Special"
    },
    firstProfit: {
      title: "First Profit",
      description: "Made your first profitable trade"
    },
    profitStreak: {
      title: "Profit Streak",
      description: "5 consecutive profitable days"
    },
    riskMaster: {
      title: "Risk Master",
      description: "Never exceeded 3% daily drawdown for 30 days"
    },
    speedDemon: {
      title: "Speed Demon",
      description: "Passed evaluation in 5 days"
    },
    consistencyKing: {
      title: "Consistency King",
      description: "15 days of active trading"
    },
    profitTarget: {
      title: "Profit Target",
      description: "Reached 6% profit target"
    },
    highRoller: {
      title: "High Roller",
      description: "Trade with $100K+ capital"
    },
    winStreak: {
      title: "Win Streak",
      description: "10 winning trades in a row"
    },
    perfectMonth: {
      title: "Perfect Month",
      description: "No losing days in a month"
    },
    volumeTrader: {
      title: "Volume Trader",
      description: "Execute 1000+ trades"
    },
    profitMachine: {
      title: "Profit Machine",
      description: "Earn $100K+ in total profits"
    },
    diamondHands: {
      title: "Diamond Hands",
      description: "Hold winning position for 24+ hours"
    }
  },
  achievementModal: {
    details: "Details",
    difficulty: "Difficulty",
    status: "Status",
    earned: "Earned",
    statusLocked: "Locked",
    earnedOn: "Earned On",
    progress: "Progress",
    reward: "Reward",
    tips: "Tips",
    unlocked: "Achievement Unlocked!",
    congratulations: "Congratulations on unlocking this achievement!",
    locked: "Achievement Locked",
    completeRequirements: "Complete the requirements to unlock this achievement.",
    rarity: "Rarity",
    points: "Points",
    completed: "Completed!",
    target: "Target",
    current: "Current",
    description: "Description"
  },
  profileAchievements: {
    title: "Achievements",
    progress: "Progress",
    rarityBreakdown: "Rarity Breakdown",
    achievementDistribution: "Achievement distribution",
    recentUnlocks: "Recent Unlocks",
    latestAchievements: "Latest achievements",
    all: "All",
    earned: "earned",
    complete: "complete",
    rarityDesc: {
      common: "Basic achievements",
      rare: "Skilled performance",
      epic: "Exceptional trading",
      legendary: "Elite mastery",
      special: "Unique rewards"
    }
  },
  profileSeasons: {
    tradingSeasons: "Trading Seasons",
    season: "Season",
    pastSeasons: "Past Seasons",
    finalLevel: "Final Level",
    level: "Level",
    current: "Current"
  },
  profileTradingStats: {
    title: "Trading Statistics",
    totalTrades: "Total Trades",
    allTimeExecuted: "All time executed",
    tradedLots: "Traded Lots",
    totalExecuted: "Total executed",
    winRate: "Win Rate",
    profitFactor: "Profit Factor",
    riskAdjusted: "Risk adjusted",
    averagePerformance: "Average Performance",
    avgWin: "Avg Win",
    avgLoss: "Avg Loss",
    dailyProfit: "Daily avg. P&L",
    extremes: "Extremes",
    bestDay: "Best Day",
    worstDay: "Worst Day",
    tradingDays: "Trading Days",
    consistency: "Consistency",
    maxWins: "Max Wins",
    maxLosses: "Max Losses",
    largestWin: "Largest Win",
    tradingHoursDistribution: "Trading Hours Distribution",
    lots: "lots",
    trades: "trades",
    marketDistribution: "Market Distribution",
    totalLots: "Total Lots",
    ofTotal: "of total",
    noData: "No closed trades available yet."
  },
  profileConnections: {
    title: "Trading Network",
    tradingNetwork: "Trading Network",
    connectWithTraders: "Connect with traders",
    total: "Total",
    followers: "Followers",
    following: "Following",
    searchConnections: "Search connections...",
    searchNewByUsername: "Search new by username...",
    userFound: "User Found",
    follow: "Follow",
    notFound: "Not Found",
    tier: "Tier",
    funded: "Funded",
    evaluation: "Evaluation",
    seasons: "Seasons",
    trades: "Trades",
    lastActive: "Last active",
    unfollow: "Unfollow"
  },
  documents: {
    title: "Documents",
    documentCenter: "Document Center",
    invoicesAgreements: "Invoices & agreements",
    invoiceTabTitle: "Invoices",
    agreementsTabTitle: "Agreements",
    all: "All",
    paid: "Paid",
    active: "Active",
    pending: "Pending",
    searchInvoices: "Search invoices...",
    searchAgreements: "Search agreements...",
    invoices: "Invoices",
    invoicesFound: "invoices found",
    fundedAgreements: "Funded Agreements",
    agreementsFound: "agreements found",
    invoice: "Invoice",
    amount: "Amount",
    fundedAgreement: "Funded Agreement",
    account: "Account",
    signed: "Signed",
    evaluationPassed: "Evaluation passed",
    contractCreated: "Contract created",
    pendingSignature: "Pending Signature",
    completed: "Completed",
    passedAccount: "Passed Account",
    fundedAccount: "Funded Account",
    terminated: "Terminated",
    awaitingFee: "Awaiting Fee",
    payFundedFee: "Pay Funded Fee",
    noInvoicesFound: "No Invoices Found",
    noInvoicesFoundCriteria: "No invoices match your current search criteria.",
    status: {
      paid: "Paid",
      active: "Active",
      pending: "Pending",
      terminated: "Terminated",
      Terminated: "Terminated",
      failed: "Failed",
      Completed: "Completed",
      PendingSignature: "Pending Signature",
      AwaitingFee: "Awaiting Fee",
      Provisioning: "Provisioning"
    }
  },
  profileSettings: {
    title: "Profile Settings",
    customizationHub: "Customization Hub",
    personalizeExperience: "Personalize your experience",
    profile: "Profile",
    privacy: "Privacy",
    notifications: "Notifications",
    security: "Security",
    manageProfileInfo: "Manage your profile information",
    controlWhoCanSee: "Control who can see your information",
    customizeNotifications: "Customize your notifications",
    secureAccount: "Secure your account",
    settingsSaved: "Settings Saved!",
    savingChanges: "Saving Changes...",
    saveChanges: "Save Changes",
    saveAllChanges: "Save All Changes",
    settings: "Settings"
  },
  profileTab: {
    profilePicture: "Profile Picture",
    uploadNew: "Upload New",
    remove: "Remove",
    uploading: "Uploading...",
    uploadSuccess: "Avatar updated successfully",
    uploadError: "Upload failed. Please try again.",
    fileTooLarge: "File too large. Max 5 MB.",
    unsupportedFileType: "Unsupported file type. Use JPEG, PNG, or WebP.",
    basicInformation: "Basic Information",
    displayName: "Display Name",
    enterDisplayName: "Enter your display name",
    username: "Username",
    enterUsername: "Enter your username",
    emailAddress: "Email Address",
    enterEmail: "Enter your email address",
    addressInformation: "Address Information",
    street: "Street",
    enterStreet: "Enter your street address",
    street2: "Address Line 2",
    enterStreet2: "Apartment, suite, etc. (optional)",
    postalCode: "Postal Code",
    enterPostalCode: "Enter your postal code",
    city: "City",
    enterCity: "Enter your city",
    stateProvince: "State / Province",
    enterStateProvince: "Enter your state or province",
    country: "Country",
    selectCountry: "Select your country",
    addressSaved: "Address updated successfully",
    addressSaveError: "Failed to update address. Please try again.",
    savingAddress: "Saving..."
  },
  privacyTab: {
    profileVisibility: "Profile Visibility",
    publicAnyone: "Public - Anyone can view",
    followersOnly: "Followers Only - Only followers can view",
    privateOnly: "Private - Only you can view",
    showAchievements: "Show Achievements",
    showAchievementsDesc: "Display your achievements on your public profile",
    allowMessages: "Allow Messages",
    allowMessagesDesc: "Allow other traders to send you messages"
  },
  notificationsTab: {
    emailNotifications: "Email Notifications",
    emailNotificationsDesc: "Receive important updates via email",
    notifications: "Notifications",
    pushNotifications: "Push Notifications",
    pushNotificationsDesc: "Receive real-time notifications in your browser",
    followerNotifications: "Follower Notifications",
    followerNotificationsDesc: "Get notified when someone follows you",
    marketUpdates: "Market Updates",
    marketUpdatesDesc: "Receive important market news and updates",
    achievementNotifications: "Achievement Notifications",
    achievementNotificationsDesc: "Get notified when you unlock new achievements",
    emailFollowerNotifications: "Email Follower Notifications",
    emailFollowerNotificationsDesc: "Receive emails when someone follows you",
    emailMarketUpdates: "Email Market Updates",
    emailMarketUpdatesDesc: "Receive market news and updates via email",
    emailAchievementNotifications: "Email Achievement Notifications",
    emailAchievementNotificationsDesc: "Receive achievement notifications via email"
  },
  securityTab: {
    changePassword: "Change Password",
    changePasswordDesc: "Update your account password regularly to keep it secure.",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    atLeast8Characters: "At least 12 characters",
    uppercaseLetter: "Uppercase letter",
    lowercaseLetter: "Lowercase letter",
    number: "Number",
    specialCharacter: "Special character",
    passwordsDoNotMatch: "Passwords do not match.",
    hidePassword: "Hide password",
    showPassword: "Show password",
    reset: "Reset",
    savePassword: "Save Password",
    saving: "Saving...",
    passwordChanged: "Password changed successfully!",
    passwordChangeFailed: "Failed to change password. Please try again.",
    reenterPassword: "Re-enter your new password"
  },
  twoFactor: {
    title: "Two-Factor Authentication",
    description: "Add an extra layer of security to your account.",
    authenticatorApp: "Authenticator App",
    enabled: "Active",
    disabled: "Inactive",
    enabledDesc: "Your account is protected with two-factor authentication.",
    disabledDesc: "Enable 2FA to add an extra layer of security.",
    enable: "Enable",
    disable: "Disable",
    enabledSuccess: "Two-factor authentication has been enabled successfully!",
    disabledSuccess: "Two-factor authentication has been disabled.",
    disableFailed: "Failed to disable two-factor authentication. Please try again.",
    setupTitle: "Set Up 2FA",
    setupSubtitle: "Secure your account with an authenticator app",
    setupFailed: "Failed to start 2FA setup. Please try again.",
    verifyFailed: "Verification failed. Please check the code and try again.",
    step1Title: "Install an Authenticator App",
    step1Desc: "Download and install an authenticator app on your mobile device. You will use it to generate verification codes.",
    recommendedApps: "Recommended apps:",
    continue: "Continue",
    initializing: "Initializing...",
    step2Title: "Scan QR Code",
    step2Desc: "Open your authenticator app and scan this QR code.",
    manualEntry: "Can't scan? Enter this key manually:",
    step3Title: "Verify Setup",
    step3Desc: "Enter the 6-digit code from your authenticator app to complete the setup.",
    verificationCode: "Verification Code",
    back: "Back",
    activate: "Activate 2FA",
    verifying: "Verifying...",
    switchToEmail: "Switch back to Email"
  },
  comparisonSection: {
    badge: "Why Nextproptrader?",
    title: "We're",
    titleHighlight: "Different",
    titleEnd: "From Other Prop Firms",
    subtitle: "See why thousands of traders choose Nextproptrader over traditional prop trading firms.",
    features: {
      profitSplit: "Profit Split",
      payoutFrequency: "Payout Frequency",
      hiddenFees: "Hidden Fees",
      platformQuality: "Platform Quality",
      miniMicroScaling: "Mini/Micro scaling",
      evaluationTime: "Evaluation Time"
    },
    nextprop: {
      profitSplit: "100%",
      payoutFrequency: "Daily",
      hiddenFees: "Transparency",
      platformQuality: "Unique & Live",
      miniMicroScaling: "1:10 fair scale",
      evaluationTime: "Only 5 Days"
    },
    others: {
      profitSplit: "75-90%",
      payoutFrequency: "Weekly/Monthly",
      hiddenFees: "Multiple fees",
      platformQuality: "Basic/Limited",
      miniMicroScaling: "1:1 unfavorable",
      evaluationTime: "10-30+ Days"
    },
    table: {
      features: "Features",
      featuresDesc: "What matters most",
      nextproptrader: "Nextproptrader",
      industryLeader: "INDUSTRY LEADER",
      otherPropFirms: "Other Prop Firms",
      industryStandard: "Industry Standard"
    },
    summary: {
      title: "The Clear Winner",
      description: "Nextproptrader consistently outperforms other prop firms across all key metrics that matter to traders."
    },
    benefits: {
      profitSplit: {
        title: "100% Profit Split",
        description: "Keep everything you earn. No hidden cuts or fees."
      },
      dailyPayouts: {
        title: "Daily Payouts",
        description: "Access your profits immediately, not weeks later."
      },
      transparentRules: {
        title: "Transparent Rules",
        description: "Clear, fair rules with no surprise restrictions."
      },
      fastEvaluation: {
        title: "Fast Evaluation",
        description: "Get funded in just 5 trading days."
      }
    },
    cta: {
      title: "Ready to Experience the",
      titleHighlight: "Difference?",
      description: "Join thousands of traders who've made the switch to a better prop trading experience.",
      button: "Start Your Evaluation"
    }
  },
  transparencySection: {
    badge: "Pure Transparency",
    title: "Only 2 Simple Rules.",
    titleHighlight: "No Hidden Traps.",
    subtitle: "While other prop firms bury you in complex regulations to avoid paying you out, we keep it radically simple. Two clear consistency rules in funded — that's it.",
    others: {
      title: "Other Prop Firms",
      subtitle: "Complex rules designed to fail you",
      rule1: "Complex consistency rules that change without notice",
      rule2: "Account deletion after just 6 payouts — start over from scratch",
      rule3: "Hidden restrictions that only surface when you request a payout",
      rule4: "Elaborate rule systems designed to make payouts nearly impossible",
      rule5: "New rules retroactively applied to existing accounts"
    },
    us: {
      title: "Nextproptrader",
      subtitle: "Only 2 clear funded rules",
      rule1: "Lucky Punch Rule: No single trade may exceed 30% of total P&L",
      rule2: "Scaling Plan: Every $2,500 unlocks one additional contract",
      rule3: "That's it. No hidden rules, no surprises, no small print",
      conclusion: "Two rules. Full transparency. Your success is the only thing that matters."
    },
    rules: {
      luckyPunch: {
        title: "Lucky Punch Rule",
        description: "Your biggest single trade must not exceed 30% of your total profit. This ensures you're building consistent performance — not relying on one lucky shot.",
        exampleTitle: "Practical Example",
        example: {
          passLabel: "Compliant",
          passText: "Total P&L: $5,000. Biggest trade: $1,200 (24%). That's well within the 30% limit — consistent trading, no issues.",
          failLabel: "Not Compliant",
          failText: "Total P&L: $3,000. Biggest trade: $1,500 (50%). One trade accounts for more than 30% — this indicates a lucky punch rather than consistent trading.",
          note: "This rule simply ensures your profits come from consistent skill, not one single outlier trade. It protects both you and the firm."
        }
      },
      scalingPlan: {
        title: "Scaling Plan",
        description: "You start with a base number of contracts. For every $2,500 in profit, you unlock one additional contract. This ensures you scale your trading safely alongside your growing account.",
        exampleTitle: "Practical Example",
        example: {
          passLabel: "Example Progression",
          passText: "You start with 1 contract. After earning $2,500 you can trade 2 contracts. After $5,000 total profit you unlock 3 contracts — and so on, step by step.",
          failLabel: "What Doesn't Work",
          failText: "Trying to trade 5 contracts on day one with a fresh funded account. The scaling plan ensures you grow your size gradually as your profits prove you're ready.",
          note: "The scaling plan protects your account from outsized risk in the early stages. As you grow your profits, you naturally grow your trading capacity."
        }
      }
    },
    showExample: "Show Example",
    hideExample: "Hide Example",
    bottom: {
      title: "No Fine Print.",
      titleHighlight: "Just Fair Trading.",
      description: "While competitors invent new rules to avoid paying you, we give you exactly two simple consistency rules. Everything else is in your hands. Trade your way — get paid your way."
    }
  },
  platformSection: {
    badge: "NEXTPROPTRADER",
    title: "Why Prop Traders",
    titleHighlight: "Choose Us",
    subtitle: "From consistent payouts to a real trading-driven model, we offer the infrastructure, support, and vision serious traders need to succeed.",
    features: {
      reliablePayouts: {
        title: "Reliable Payouts",
        description: "Unlike many firms that invent excuses to withhold your profits, we've never missed a payout. Period. Get paid reliably via bank transfer, PayPal, or crypto — no delays, no drama."
      },
      technology: {
        title: "Industry-Leading Technology",
        description: "From connectivity to our trader dashboard, our technology is among the most advanced in the industry. We constantly innovate to stay one step ahead — giving you the speed, stability, and tools you need to perform."
      },
      partnerships: {
        title: "Long-Term Partnerships",
        description: "We're not looking for one-time evaluations — we're here to build long-term relationships. Through our program, successful traders gain access to exclusive opportunities and deeper capital scaling over time."
      },
      builtToTrade: {
        title: "Built to Trade — Not Just to Sell",
        description: "Unlike discount prop firms that survive on evaluation fees alone, we operate real infrastructure that thrives on actual trading performance. Our business model is aligned with your success — because we grow when you do."
      }
    },
    profitSplit: {
      title: "Profit Split",
      subtitle: "Industry Leading",
      badge: "INDUSTRY LEADING",
      keepEverything: "You Keep Everything You Earn"
    },
    explanation: {
      title: "Why 100% Profit Split?",
      believeInSuccess: "We believe in your success.",
      paragraph1: "Unlike traditional prop firms that take 10-20% of your profits, we let you keep 100% of what you earn because your trading skills deserve full reward.",
      paragraph2: "We don't take a cut — because we scale with you. When you're funded and perform well, we replicate your trades in the background using larger position sizes. You keep 100% of your profits — we earn by scaling your edge. A win-win model built on trust and performance."
    },
    benefits: {
      hiddenFees: {
        value: "$0",
        label: "Hidden Fees"
      },
      earningPotential: {
        value: "∞",
        label: "Earning Potential"
      }
    }
  },
  tradingActivity: {
    title: "Trading Activity",
    subtitle: "Live Performance",
    description: "Real-time trading performance and analytics"
  },
  recentTrades: {
    title: "Today's Trades",
    subtitle: "Latest trading activity",
    quantity: "Lots",
    entry: "Entry",
    current: "Current",
    exit: "Exit",
    pnl: "P&L",
    duration: "Duration",
    running: "Running",
    open: "Open",
    closed: "Closed",
    winners: "Winners",
    losers: "Losers",
    tradedLots: "Traded Lots",
    avgNetPnL: "Avg Net P&L",
    noTrades: "No Trades Today",
    noTradesDesc: "No trades have been executed today"
  },
  pnlCalendar: {
    title: "P&L Calendar",
    subtitle: "Daily performance overview",
    allAccounts: "All Accounts",
    totalPnl: "Total P&L",
    totalTrades: "Trades",
    winDays: "Win Days",
    lossDays: "Loss Days",
    days: {
      sun: "Sun",
      mon: "Mon",
      tue: "Tue",
      wed: "Wed",
      thu: "Thu",
      fri: "Fri",
      sat: "Sat"
    }
  },
  panelSwitcher: {
    performance: "Performance",
    trades: "Trades"
  },
  dailyPerformanceChart: {
    title: "Performance Chart",
    subtitle: "Last 14 Trading Days",
    today: "today",
    dailyPnL: "Daily P&L",
    tradePnL: "Trade P&L",
    bestDay: "Best Day",
    bestTrade: "Best Trade",
    avgDaily: "Avg Daily",
    avgPnLToday: "Avg. P&L Today",
    last14Days: "last 14 days",
    worstDay: "Worst Day",
    worstTrade: "Worst Trade",
    trades: "trades",
    tradingDays: "Trading Days",
    perDay: "per day"
  },
  accountPerformance: {
    title: "Account Performance",
    subtitle: "All trading accounts",
    leading: "Leading",
    since: "Since",
    noData: "No data available",
    account: "Account",
    startBalance: "Start Balance",
    balance: "Balance",
    netPnL: "Net P&L",
    performance: "Performance",
    todaysPnL: "Today's P&L"
  },
  todaysSession: {
    title: "Today's Session",
    livePerformance: "Live performance",
    active: "Active",
    totalTrades: "Total Trades",
    sessionPnL: "Session P&L",
    winRate: "Win Rate",
    winningTrades: "Winning Trades",
    losingTrades: "Losing Trades",
    avgWin: "Avg Win",
    avgLoss: "Avg Loss",
    largestWin: "Largest Win",
    largestLoss: "Largest Loss",
    avgTradeDuration: "Avg Trade Duration",
    sessionSummary: "Session Summary"
  },
  controlPanel: {
    title: "Control Panel",
    subtitle: "Trade management",
    live: "Live",
    openPositions: "Open Positions",
    active: "active",
    noOpenPositions: "No open positions",
    quickActions: "Quick Actions",
    closeAllPositions: "Close All Positions",
    closingPositions: "Closing positions...",
    close: "Close",
    closing: "Closing...",
    confirmCloseAll: "Close All Positions?",
    confirmMessage: "Are you sure you want to close all {count} open positions?",
    cancel: "Cancel",
    closeAll: "Close All"
  },
  addAccountModal: {
    title: "Add New Account",
    subtitle: "Choose your evaluation account",
    mostPopular: "MOST POPULAR",
    tradingCapital: "Trading Capital",
    only: "Only",
    per30Days: "/30 days",
    getAccess: "Get access to",
    capital: "capital",
    startEvaluation: "START EVALUATION",
    allPlansInclude: "All Plans Include",
    fullPlatformAccess: "Full Platform Access",
    completeAccess: "Complete access to all trading tools",
    level2MarketData: "Level 2 Market Data",
    chooseDataFeed: "Choose your preferred data feed",
    premiumSupport: "Premium Support",
    professionalSupport: "24/7 professional trading support"
  },
  footer: {
    traderFunding: "Trader funding",
    description: "We help traders monetize their simulated performance through funding programs, pro-level tools, and real trading environments — without risking personal capital.",
    newsletter: {
      title: "Exclusive Deals & Limited Discounts",
      description: "Be the first to know about limited-time offers and exclusive trader discounts.",
      placeholder: "Enter your email address",
      subscribe: "Subscribe Free",
      privacy: "No spam. Unsubscribe anytime. Your data is protected.",
      subscribing: "Subscribing...",
      successMessage: "Please check your email and confirm your subscription.",
      errorMessage: "Something went wrong. Please try again.",
      invalidEmail: "Please enter a valid email address.",
      confirm: {
        title: "Confirm Your Subscription",
        subtitle: "Newsletter Confirmation",
        confirming: "Confirming your subscription...",
        success: "Your subscription has been confirmed successfully!",
        successDetail: "You will now receive our latest deals and exclusive discounts directly to your inbox.",
        error: "Confirmation failed. The link may be invalid or expired.",
        backToHome: "Back to Homepage"
      },
      unsubscribe: {
        title: "Unsubscribe from Newsletter",
        subtitle: "Newsletter Preferences",
        description: "Are you sure you want to unsubscribe from our newsletter? You will no longer receive exclusive deals and discounts.",
        button: "Unsubscribe",
        unsubscribing: "Unsubscribing...",
        success: "You have been successfully unsubscribed.",
        successDetail: "You will no longer receive newsletter emails from us.",
        error: "Unsubscription failed. The link may be invalid or expired.",
        backToHome: "Back to Homepage"
      }
    },
    ourProgram: {
      title: "Our Program",
      fundingProcess: "The Funding Process",
      softwareSolution: "Our Software Solution",
      profitSplit: "100% Profit Split",
      pricing: "Our Pricing"
    },
    association: {
      title: "Association",
      partnership: "Partnership",
      whiteLabel: "White Label",
      affiliateProgram: "Affiliate Program"
    },
    support: {
      title: "Support",
      faq: "FAQ",
      contact: "Contact"
    },
    copyright: "© {year} Nextproptrader LLC. All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    disclaimers: {
      generalDisclosure: {
        title: "General Disclosure",
        content: "The materials and content provided by Nextproptrader LLC, whether on our website, through distributed documents, or other communications, are intended solely for general informational purposes. This content does not constitute investment advice, an offer to buy or sell securities, or an endorsement of any financial instruments, companies, or funds. Users should not interpret the information as personalized financial advice. The information provided is not targeted at any specific jurisdiction and should not be used in any manner that would contravene local laws or regulations. Nextproptrader LLC, a registered entity in Business Center 1, M Floor, Meydan Grand Stand, Dubai, UAE, adheres to all relevant local, state, and federal laws. © {year}. All rights reserved."
      },
      riskDisclosure: {
        title: "Risk Disclosure",
        content: "Trading futures, forex, and other leveraged products involves substantial risk of loss and is not suitable for all investors. Past performance is not necessarily indicative of future results. You should carefully consider whether trading is suitable for you in light of your circumstances, knowledge, and financial resources. You may lose all or more of your initial investment. Opinions, market data, and recommendations are subject to change at any time. Nextproptrader is not a registered investment advisor and does not provide investment advice. All trading decisions are made by the individual trader."
      },
      hypotheticalPerformance: {
        title: "Hypothetical Performance Disclosure",
        content: "Hypothetical performance results have many inherent limitations. No representation is being made that any account will or is likely to achieve profits or losses similar to those shown. In fact, there are frequently sharp differences between hypothetical performance results and the actual results subsequently achieved by any particular trading program. One of the limitations of hypothetical performance results is that they are generally prepared with the benefit of hindsight. In addition, hypothetical trading does not involve financial risk, and no hypothetical trading record can completely account for the impact of financial risk in actual trading. The ability to withstand losses or to adhere to a particular trading program in spite of trading losses are material points which can also adversely affect actual trading results."
      },
      finalNotice: "This website and its content are for informational purposes only. Trading involves risk and may not be suitable for all investors. Please read all risk disclosures before trading. Nextproptrader LLC is not responsible for any trading losses incurred by users of this platform."
    },
    systemStatus: {
      title: "System Status",
      subtitle: "Real-time platform monitoring",
      allSystemsOperational: "All Systems Operational",
      platformRunning: "Platform is running smoothly",
      overallUptime: "Overall Uptime",
      coreSystems: "Core Systems",
      marketDataFeeds: "Market Data Feeds",
      operational: "Operational",
      maintenance: "Maintenance",
      uptime: "Uptime",
      responseTime: "Response Time",
      latency: "Latency",
      statusUpdates: "Status Updates",
      lastUpdated: "Last updated",
      refreshes: "Refreshes every 30 seconds",
      liveMonitoring: "Live Monitoring",
      systems: {
        tradingPlatform: {
          name: "Trading Platform",
          description: "Core trading infrastructure"
        },
        userDashboard: {
          name: "User Dashboard",
          description: "Account management system"
        },
        paymentSystem: {
          name: "Payment System",
          description: "Payout processing"
        },
        apiServices: {
          name: "API Services",
          description: "Third-party integrations"
        }
      },
      dataFeeds: {
        rithmic: "Futures market data",
        dxfeed: "Multi-asset market data"
      }
    }
  },
  hero: {
    badge: "Nextproptrader 2.0 – Prop trading, redefined.",
    headline1: "Your Trades.",
    headline2: "Our Capital.",
    headline3: "Real Profits.",
    description: "With us, you can monetize your sim trading — completely risk-free. Trade in a safe environment and receive",
    profitSplit: "100% of your profits",
    descriptionEnd: ". No stress — just your skills turning into real profits.",
    getFundedButton: "Get Funded Now",
    learnMoreButton: "Learn More",
    stats: {
      capitalAllocated: "In Capitalizations",
      capitalSubtitle: "Funded Capital",
      fundedAccounts: "Funded Accounts",
      accountsSubtitle: "Trusted by Thousands",
      tradesExecuted: "Trades Executed",
      tradesSubtitle: "Millions of Ideas. One Platform."
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "Live Trading Environment",
      fundedBadge: "Funded",
      accountBalance: "Account Balance",
      todayPerformance: "today",
      possiblePayout: "Possible Payout",
      payoutButton: "Payout",
      profitSplit: "100%",
      profitSplitLabel: "Profit Split",
      instrument: "NQ1! Futures",
      liveData: "Live Data",
      todayProfit: "today"
    }
  },
  header: {
    process: "Process",
    pricing: "Pricing",
    payouts: "Payouts",
    contact: "Contact",
    login: "Login",
    register: "Register",
    getStarted: "Register",
    backToMainSite: "Back to Main Site"
  },
  logoutModal: {
    title: 'Logging Out',
    subtitle: 'Please wait while we securely log you out',
    loggingOut: 'Logging out...',
    securityMessage: 'We are securely clearing your session and protecting your account data.'
  },
  loginModal: {
    welcomeBack: "Welcome Back",
    signInToAccount: "Sign in to your account",
    resetPassword: "Login",
    enterEmailToReset: "Reset Password",
    resetInstructions: "Enter your email address to reset your password",
    resetLinkSent: "Please check your emails",
    sendingResetLink: "Link will be sent...",
    emailAddress: "Email Address",
    enterYourEmail: "Enter your email",
    emailOrUsername: "Email or Username",
    enterEmailOrUsername: "Enter your email or username",
    password: "Password",
    enterYourPassword: "Enter your password",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    signIn: "Sign In",
    enterEmailAddress: "Enter your email address",
    resetLinkInfo: "We'll send you a secure link to reset your password. Please check your email inbox and spam folder.",
    sendResetLink: "Send Reset Link",
    resendInSeconds: "Resend available in {s}s",
    backToLogin: "← Back to Login",
    or: "or",
    dontHaveAccount: "Don't have an account?",
    createOneNow: "Create one now",
    signingIn: "Signing in...",
    enterSecurityCode: "Security Code",
    enterCodeFromApp: "OTP Authentication",
    enterCodeFromEmail: "Enter the code sent to your email",
    securityCode: "Enter the code:",
    verifyAndSignIn: "Sign In",
    verifying: "Verifying",
    resetError: "An error occurred. Please try again.",
    setNewPassword: "New Password",
    enterNewPasswordSubtitle: "Set your new password",
    newPasswordInstructions: "Please enter your new password. It must be at least 8 characters long.",
    newPassword: "New Password",
    enterNewPassword: "Enter your new password",
    confirmPassword: "Confirm Password",
    repeatNewPassword: "Repeat your new password",
    passwordsMismatch: "Passwords do not match.",
    passwordTooShort: "Password must be at least 12 characters and contain a number and a special character.",
    resettingPassword: "Saving...",
    saveNewPassword: "Save New Password",
    passwordResetSuccess: "Password Changed",
    passwordResetSuccessMessage: "Your password has been reset successfully. You can now sign in with your new password.",
    backToLoginButton: "Back to Login",
    loginFailed: "Login failed. Please check your email/username and password.",
    accountBlocked: "Your account has been blocked. Please contact support at support@nextproptrader.com"
  },
  evaluationProcess: {
    badge: "Your Path To Funding",
    title: "Simple",
    titleHighlight: "4-Step",
    titleEnd: "Evaluation Process",
    subtitle: "Our streamlined evaluation process is designed to identify talented traders and get them funded quickly.",
    steps: {
      step1: {
        title: "Start Your Evaluation",
        subtitle: "Begin trading",
        description: "Choose your account size and start trading with our simulated capital. No risk to your own money.",
        duration: "Day 1",
        requirement: "Account Setup"
      },
      step2: {
        title: "Hit Profit Target",
        subtitle: "Prove your skills",
        description: "Reach your profit target while following our risk management rules. Show consistent trading performance.",
        duration: "5-30 days",
        requirement: "6-8% Profit Target"
      },
      step3: {
        title: "Risk Management",
        subtitle: "Stay within limits",
        description: "Maintain proper risk management throughout the evaluation. Never exceed maximum drawdown limits.",
        duration: "Ongoing",
        requirement: "Max Drawdown"
      },
      step4: {
        title: "Get Funded",
        subtitle: "Receive real capital",
        description: "Congratulations! You've passed the evaluation and now receive access to your funded account.",
        duration: "Within minutes",
        requirement: "Account Activation"
      }
    },
    stepContent: {
      step1: {
        chooseCapital: "Choose Capital",
        availableRange: "$10K - $250K available",
        startTrading: "Start Trading",
        beginImmediately: "Begin immediately"
      },
      step2: {
        profitTargetProgress: "Profit Target Progress",
        ofAmount: "of $50K = $3,000"
      },
      step3: {
        riskManagement: "Risk Management",
        withinLimits: "✓ Within Limits",
        maxDrawdown: "Max Drawdown",
        dependsOnAccount: "depends on account size"
      },
      step4: {
        congratulations: "Congratulations!",
        accountPreparing: "Your funded account is being prepared"
      }
    },
    rules: {
      title: "Evaluation",
      titleHighlight: "Rules",
      subtitle: "Simple and transparent rules for your evaluation success",
      rule1: {
        title: "5 Day Funding",
        description: "Get funded after 5 trading days and there's no maximum either. You can take as much time as you need."
      },
      rule2: {
        title: "Max Lot Size",
        description: "Don't exceed the maximum number of lots allowed for you. Each account has a different limit."
      },
      rule3: {
        title: "Max Loss Limit",
        description: "Limit your risk and trade effectively. You must not fall below the trailing drawdown."
      },
      rule4: {
        title: "Trading Hours",
        description: "You must close all positions by 3:15 PM CST at the latest. Trading resumes at 5:00 PM CST."
      }
    }
  },
  solutions: {
    badge: "Empowering Traders With Proprietary Precision",
    title: "Built for",
    titleHighlight: "Professional",
    titleEnd: "Prop Trading",
    subtitle: "Our professional platform provides the tools and infrastructure prop traders need to succeed in today's futures markets.",
    poweredBy: "Powered by:",
    premiumDataFeeds: {
      title: "Premium Data Feeds",
      description: "Professional CME market data from industry-leading providers with real-time execution.",
      dataPartners: "Our Data Partners:",
      subtitle: "Real-Time Level 2 Data",
      badge: "CME Market Data"
    },
    dailyPayouts: {
      title: "Daily Payouts",
      description: "Fast and flexible payout options with daily withdrawals across multiple payment methods.",
      badge: "Fast & Flexible",
      features: {
        dailyWithdrawals: "Daily withdrawals",
        bankTransfer: "Bank transfer",
        paypalCrypto: "PayPal & Crypto"
      }
    },
    payoutMethods: {
      bank: "Bank",
      transfer: "Transfer",
      paypal: "PayPal",
      payments: "Payments",
      crypto: "Crypto",
      downloadReceipt: "Download Receipt"
    },
    payoutDemo: {
      approved: "PAYOUT APPROVED",
      paid: "PAID",
      amount: "Payout Amount",
      date: "Date:",
      to: "To:",
      method: "Method:",
      account: "Account:",
      congratulations: "Congratulations on your payout!",
      fundsTransferred: "Your funds have been successfully transferred to your account."
    }
  },
  platformShowcase: {
    badge: "One Platform. All Tools. No Limits.",
    title: "All-in-One",
    titleHighlight: "Trading Hub",
    titleEnd: "for Prop Traders",
    subtitle: "All your trading. One smart dashboard. Analyze, manage, and execute — faster, clearer, better.",
    platform: {
      dashboard: "Dashboard",
      subtitle: "Unified interface",
      badge: "NXT Hub 2.0",
      liveData: "Live Data",
      currentSlideTitle: "Advanced Charting Suite"
    },
    features: {
      security: "Bank-Grade Security",
      securityDesc: "256-bit encryption",
      execution: "Ultra-Fast Execution",
      executionDesc: "Sub-millisecond",
      indicators: "100+ Indicators",
      indicatorsDesc: "Technical analysis",
      awardWinning: "Award-Winning",
      awardWinningDesc: "Industry leader"
    },
    floating: {
      realTimeData: "Real-Time Market Data",
      advancedAnalytics: "Advanced Analytics",
      lightningExecution: "Lightning Execution",
      uptime: "Uptime",
      latency: "Latency",
      support: "Support"
    }
  },
  pricingSection: {
    badge: "Choose Your Trading Capital",
    title: "Start Trading with",
    titleHighlight: "Our Capital",
    subtitle: "Choose the perfect account size for your trading style. All plans include full platform access and professional support.",
    mostPopular: "Most popular",
    tradingCapital: "Trading Capital",
    only: "Only",
    month: "month",
    per30Days: "/{{days}} days",
    getAccess: "Get access to {{capital}} capital",
    getFunded: "GET FUNDED",
    allPlansInclude: "All Plans Include",
    fullPlatformAccess: "Full Platform Access",
    completeAccess: "Complete access to all trading tools",
    level2MarketData: "Level 2 Market Data",
    chooseDataFeed: "Choose your preferred data feed",
    premiumSupport: "Premium Support",
    professionalSupport: "24/7 professional trading support",
    minTradingDays_one: "Min. {{days}} Trading Day",
    minTradingDays_other: "Min. {{days}} Trading Days",
    profitSplit: "{{split}}% Profit Split",
    maxLots_one: "Max. {{lots}} Lot ({{micros}} Micros)",
    maxLots_other: "Max. {{lots}} Lots ({{micros}} Micros)",
    profitTarget: "${{target}} Profit Target",
    maxLoss: "${{loss}} Max. Loss",
    loadingProducts: "Loading products...",
    errorLoading: "Error loading products",
    noProducts: "No products available"
  },
  testimonials: {
    badge: "Verified Payouts",
    title: "Thousands of Traders Paid Out.",
    titleHighlight: "Millions Verified.",
    titleEnd: "Trust Earned.",
    subtitle: "Real traders, real profits, real payouts. See the certificates from our funded traders worldwide.",
    certificate: {
      title: "Payout Certificate",
      fundedAccount: "Funded Account",
      account: "Account",
      trader: "Trader",
      payout: "Payout",
      certificateId: "Certificate ID",
      paid: "PAID"
    }
  },
  purchaseModal: {
    title: "Complete Purchase",
    subtitle: "Secure checkout process",
    resetSubtitle: "Reset account balance and statistics",
    resetDescription: "Reset your account statistics and account balance. Please note that this product does not extend the term of your trading account.",
    extensionDescription: "This product extends your trading account for an additional 30 days. It has no effect on your trading statistics.",
    fundedFeeDescription: "This is the activation fee for your new Funded account and any additional Funded accounts activated during this period.",
    personalInformation: "Personal Information",
    personalInfoDescription: "Please provide your personal details",
    firstName: "First Name",
    lastName: "Last Name",
    enterFirstName: "Enter your first name",
    enterLastName: "Enter your last name",
    emailAddress: "Email Address",
    enterEmail: "Enter your email address",
    country: "Country",
    countryOrRegion: "Country or region",
    selectCountry: "Select your country",
    searchCountries: "Search countries...",
    noCountriesFound: "No countries found",
    streetAddress: "Street Address",
    address: "Address",
    enterStreetAddress: "Enter your street address",
    postalCode: "Postal Code",
    enterPostalCode: "Enter your postal code",
    city: "City",
    enterCity: "Enter your city",
    challenge: "Evaluation",
    profitTarget: "Profit Target",
    maxDailyLoss: "Max Daily Loss",
    maxTotalLoss: "Max Total Loss",
    maxLoss: "Max Loss",
    profitSplit: "Profit Split",
    minTradingDays: "Min. Trading Days",
    maxLots: "Max Contracts",
    continue: "Continue",
    continueToPayment: "Continue to Payment",
    personal: "Personal",
    payment: "Payment",
    paymentDetails: "Payment Details",
    paymentInformation: "Payment Information",
    securePayment: "Secure payment processing",
    paymentMethod: "Payment Method",
    currency: "Currency",
    card: "Card",
    cardNumber: "Card number",
    enterCardNumber: "1234 5678 9012 3456",
    expiration: "Expiration",
    enterExpiry: "MM/YY",
    cvv: "CVV",
    enterCvv: "123",
    fullName: "Full name",
    cardholderName: "Cardholder Name",
    enterCardholderName: "John Doe",
    creditCard: "Credit Card",
    expiryDate: "Expiry Date",
    securePaymentTitle: "Secure Payment",
    securePaymentDescription: "Your payment information is encrypted and secure.",
    paypal: "PayPal",
    paypalEmail: "PayPal Email",
    enterPaypalEmail: "your.email@example.com",
    paypalPayment: "PayPal Payment",
    paypalRedirectDescription: "You will be redirected to PayPal to complete your payment",
    stripeRedirectDescription: "You will be redirected to Stripe to complete your payment securely",
    bitpayRedirectDescription: "You will be redirected to BitPay to complete your cryptocurrency payment securely",
    soon: "Soon",
    crypto: "Crypto",
    cryptocurrency: "Cryptocurrency",
    cryptoPayment: "Cryptocurrency Payment",
    selectCryptocurrency: "Select Cryptocurrency",
    cryptoInstructions: "You will receive payment instructions for {cryptoType} after order confirmation",
    cryptoImportantNote: "Please ensure you send the exact amount to the provided address",
    termsAndConditions: "I agree to the terms and conditions and privacy policy",
    reviewConfirm: "Review & Confirm",
    reviewConfirmDescription: "Please review your order before completing",
    orderSummary: "Order Summary",
    product: "Product",
    price: "Price",
    productDiscount: "Product Discount",
    discountedPrice: "Discounted Price",
    coupon: "Coupon",
    finalPrice: "Final Price",
    couponCode: "Coupon Code",
    enterCouponCode: "Enter coupon code",
    applyCoupon: "Apply",
    couponHelp: "Enter a valid coupon code to get a discount",
    couponApplied: "Coupon Applied",
    applied: "Applied",
    percentDiscountApplied: "{percent}% discount applied",
    amountDiscountApplied: "€{amount} discount applied",
    selectDataFeed: "Select Data Feed",
    targetAccount: "Target Account",
    agreeToTerms: "I agree to the",
    termsOfService: "Terms of Service",
    and: "and",
    privacyPolicy: "Privacy Policy",
    noRefundPolicy: "All sales are final - no refunds",
    previous: "Previous",
    nextStep: "Next Step",
    review: "Review",
    completePurchase: "Complete Purchase",
    processing: "Processing...",
    processingPayment: "Processing Payment...",
    purchaseSuccessful: "Purchase Successful!",
    purchaseSuccessMessage: "Your account has been created and is ready to use.",
    redirecting: "Redirecting...",
    paymentRedirectTitle: "Payment page opened",
    paymentRedirectMessage: "The payment page has been opened in a new tab. Please complete your payment there.",
    paymentRedirectCloseHint: "After completing the payment you can close this window.",
    paymentRedirectOpenAgain: "Open payment link again",
    paymentRedirectClose: "Close this window",
    accountCreated: "Your account has been created and will be available within 24 hours",
    subscriptionDisclaimer: "By creating your subscription, you allow {productName} to charge your card for this payment and future payments in accordance with their terms. You can always cancel your subscription.",
    quantity: "Quantity",
    cart: "Your Cart",
    subtotal: "Subtotal",
    tax: "Tax",
    total: "Total",
    continueToReview: "Continue to Review",
    reviewAndConfirm: "Review & Confirm",
    tradingSystem: "Trading System",
    selectTradingSystem: "Please select a data feed",
    couponDiscount: "Coupon Discount",
    invalidCoupon: "The entered coupon code does not exist or has already expired.",
    loadingQuote: "Loading price details...",
    retry: "Retry",
    useWalletBalance: "Use Wallet Balance",
    walletBalanceAvailable: "Available: {symbol}{amount}",
    walletCoversFullAmount: "Wallet covers the full amount - no external payment needed",
    walletPartialCover: "Remaining {symbol}{amount} will be charged via {method}",
    walletApplied: "Wallet Credit",
    remainingAmount: "Remaining Amount",
    volumeDiscount: "Volume Discount",
    volumeDiscountSavings: "You save {symbol}{amount} per unit",
    volumeDiscountApplied: "Volume discount applied ({percentage}% off)",
    blacklistedTitle: "Purchase Not Available",
    blacklistedMessage: "You are currently not authorized to purchase new evaluations. Please contact our support team for further details."
  },
  contactModal: {
    title: "Get in Touch",
    subtitle: "We're here to help you succeed",
    messageSentTitle: "Message Sent Successfully!",
    messageSentDescription: "Thank you for reaching out. Our team will get back to you within 24 hours.",
    exploreWhileWaiting: "In the meantime, feel free to explore our platform features or check out our evaluation process.",
    firstName: "First Name",
    enterFirstName: "Enter your first name",
    lastName: "Last Name",
    enterLastName: "Enter your last name",
    emailAddress: "Email Address",
    enterEmail: "Enter your email",
    accountNumber: "Account Number",
    accountNumberPlaceholder: "Your account number (optional)",
    subject: "Subject",
    selectSubject: "Select a subject",
    generalInquiry: "General Inquiry",
    evaluationProcess: "Evaluation Process",
    platformSupport: "Platform Support",
    fundingQuestions: "Funding Questions",
    technicalSupport: "Technical Support",
    partnership: "Partnership",
    message: "Message",
    messagePlaceholder: "Tell us how we can help you...",
    otherWaysTitle: "Other Ways to Reach Us",
    businessHours: "Business Hours",
    businessHoursTime: "Mon-Fri: 8:00 AM - 8:00 PM GST",
    sendingMessage: "Sending Message...",
    sendMessage: "Send Message",
    errorSending: "Failed to send message. Please try again.",
    overlayTitle: "Contact Us via Email",
    overlayDescription: "For any questions, concerns, or if you need support, please write to us directly at:",
    overlayButton: "Send Email"
  },
  partnershipModal: {
    title: "Strategic Partnerships",
    subtitle: "Exclusive Collaboration Opportunities",
    tabs: {
      overview: "Overview",
      brandAmbassador: "Brand Ambassador",
      exclusiveContracts: "Exclusive Contracts"
    },
    overview: {
      heroTitle: "Become our",
      heroTitleHighlight: "Partner",
      heroTitleEnd: "and grow with us",
      heroDescription: "Discover our partnership programs tailored to your needs, whether you're an influencer or an established business.",
      brandAmbassador: {
        title: "Brand Ambassador",
        subtitle: "Content Creator Program",
        description: "Perfect for influencers, educators, and content creators who want to introduce our platform to their audience.",
        benefits: {
          customCodes: "Custom referral codes and tracking",
          exclusiveContent: "Access to exclusive marketing content",
          prioritySupport: "Priority customer support",
          marketingCollaboration: "Direct marketing collaboration opportunities"
        }
      },
      exclusiveContracts: {
        title: "Exclusive Contracts",
        subtitle: "Corporate Partnerships",
        description: "Tailored agreements for established businesses, trading firms, and industry professionals seeking deeper collaboration.",
        benefits: {
          customProfitSplits: "Negotiated custom profit sharing arrangements",
          dedicatedManager: "Dedicated account manager and support team",
          whiteLabelSolutions: "White label platform and branding options",
          revenueSharingModels: "Advanced revenue sharing and partnership models"
        }
      },
      keyBenefits: {
        title: "Key Benefits of Our Partnerships",
        higherCommissions: {
          title: "Higher Commissions",
          description: "Benefit from industry-leading commission rates and bonus structures."
        },
        dedicatedSupport: {
          title: "Dedicated Support",
          description: "Receive personalized support from our partner management team."
        },
        globalReach: {
          title: "Global Reach",
          description: "Expand your brand with our international presence."
        }
      }
    },
    brandAmbassador: {
      heroTitle: "Become our",
      heroTitleHighlight: "Brand Ambassador",
      heroDescription: "As a brand ambassador, you represent Nextproptrader and benefit from exclusive advantages and commissions.",
      requirements: {
        title: "Brand Ambassador Requirements",
        audienceSize: {
          title: "Engaged Audience",
          description: "Proof of an active and engaged online presence."
        },
        contentQuality: {
          title: "High-Quality Content",
          description: "Creation of relevant and engaging content for traders."
        },
        engagementRate: {
          title: "High Engagement Rate",
          description: "Strong interaction with your community."
        },
        brandAlignment: {
          title: "Brand Alignment",
          description: "Your values align with those of Nextproptrader."
        }
      },
      exclusiveBenefits: {
        title: "Exclusive Benefits",
        customReferralCodes: {
          title: "Custom Referral Codes",
          description: "Personalized codes for your audience."
        },
        exclusiveContent: {
          title: "Exclusive Marketing Content",
          description: "Access to special banners, videos, and texts."
        },
        marketingMaterials: {
          title: "Comprehensive Marketing Materials",
          description: "Professional resources to support your promotion."
        },
        directCommunication: {
          title: "Direct Communication",
          description: "Direct line to our partner management team."
        }
      }
    },
    exclusiveContracts: {
      heroTitle: "for",
      heroTitleHighlight: "Exclusive Contracts",
      heroDescription: "Tailored partnerships for businesses and industry leaders seeking deeper integration and collaboration.",
      professionals: {
        title: "Professional Traders",
        subtitle: "Individual Agreements",
        description: "For experienced traders who want to trade with our capital and benefit from customized conditions.",
        benefits: {
          customProfitSplit: "Custom profit sharing",
          accessToAlgorithms: "Access to proprietary algorithms",
          tradeWithTeam: "Trade with our team",
          profitFromCapital: "Profit from our capital"
        }
      },
      industryLeaders: {
        title: "Industry Leaders",
        subtitle: "Strategic Alliances",
        description: "For companies seeking a white-label solution or a deeper strategic partnership.",
        benefits: {
          revenueSharing: "Revenue sharing models",
          whiteLabelOptions: "White label options",
          coMarketingOpportunities: "Co-marketing opportunities",
          customBrandingSolutions: "Custom branding solutions"
        }
      }
    },
    contact: {
      title: "Interested in a Partnership?",
      description: "Contact us to learn more about our tailored partnership programs and how we can grow together.",
      button: "Contact Us"
    }
  },
  affiliateModal: {
    title: "Affiliate Program",
    subtitle: "Earn commissions by referring traders",
    tabs: {
      overview: "Overview",
      benefits: "Benefits",
      requirements: "Requirements"
    },
    overview: {
      heroTitle: "Earn",
      heroTitleHighlight: "10% Commission",
      heroTitleEnd: "on Every Referral",
      heroDescription: "Join our affiliate program and earn generous commissions for every trader you refer to Nextproptrader.",
      features: {
        highCommissions: {
          title: "High Commissions",
          subtitle: "Industry-leading rates",
          description: "Earn 10% commission on every successful referral with potential for higher rates based on performance."
        },
        customerDiscounts: {
          title: "Customer Discounts",
          subtitle: "Value for your audience",
          description: "Your referrals get exclusive discounts, making it easier to convert and providing real value to your audience."
        }
      },
      commissionCalculator: {
        title: "Commission Calculator",
        sales: "sales",
        proPlan: "Pro Plan avg",
        mixedPlans: "Mixed plans",
        averagePlan: "Average plan",
        monthlyGoal: "Monthly goal"
      },
      partnershipRewards: {
        title: "Long-term Partnership Rewards",
        description: "Build a sustainable income stream with our trader success sharing program.",
        features: {
          traderSuccess: {
            title: "Trader Success Bonus",
            description: "Earn additional rewards when your referrals become profitable"
          },
          partnership: {
            title: "Partnership Tiers",
            description: "Unlock higher commission rates and exclusive benefits"
          },
          passiveIncome: {
            title: "Passive Income",
            description: "Continue earning from successful long-term traders"
          }
        },
        premiumBenefits: {
          title: "Premium Partnership Benefits",
          description: "Top affiliates gain access to exclusive partnership opportunities, custom landing pages, and direct collaboration with our marketing team."
        }
      }
    },
    benefits: {
      highConversion: {
        title: "High Conversion Rates",
        description: "Our transparent 100% profit split and professional platform convert exceptionally well."
      },
      premiumBrand: {
        title: "Premium Brand",
        description: "Promote a respected, professional prop trading firm with excellent reputation."
      },
      bonusPayments: {
        title: "Performance Bonuses",
        description: "Earn additional bonuses based on the long-term success of your referrals."
      },
      marketingSupport: {
        title: "Marketing Support",
        description: "Access professional marketing materials, banners, and promotional content."
      },
      realTimeTracking: {
        title: "Real-time Tracking",
        description: "Monitor your referrals, commissions, and performance with detailed analytics."
      },
      customerBenefits: {
        title: "Customer Benefits",
        description: "Your referrals receive exclusive discounts and special offers through your links."
      },
      payoutInfo: {
        title: "Payout Information",
        frequency: {
          value: "Monthly",
          label: "Payout Frequency"
        },
        minimum: {
          value: "€50",
          label: "Minimum Payout"
        },
        methods: {
          value: "Multiple",
          label: "Payment Methods"
        }
      }
    },
    requirements: {
      title: "Requirements to Join",
      nptAccount: {
        subtitle: "Account required",
        description: "You need a Nextproptrader account, which you can create either by starting an evaluation or by using the register button below."
      },
      marketingCompliance: {
        title: "Marketing Compliance",
        description: "All promotional activities must comply with our marketing guidelines and applicable regulations."
      },
      existingAccountInfo: "If you already have a Nextproptrader account, you do not need to register again. You can use your existing account for the affiliate program as well \u2013 simply log in and navigate to the Affiliate page in the menu.",
      readyToJoin: {
        title: "Ready to Join Our Affiliate Program?",
        description: "Start earning commissions today by referring traders to Nextproptrader.",
        loginButton: "Login",
        createAccountButton: "Create Account"
      },
      register: {
        title: "Create Account",
        firstnameLabel: "First name",
        firstnamePlaceholder: "Max",
        lastnameLabel: "Last name",
        lastnamePlaceholder: "Mustermann",
        emailLabel: "Email address",
        emailPlaceholder: "your@email.com",
        passwordLabel: "Password",
        passwordPlaceholder: "Choose a secure password",
        confirmPasswordLabel: "Confirm password",
        confirmPasswordPlaceholder: "Enter password again",
        passwordMismatch: "Passwords do not match.",
        submitButton: "Create Account",
        submitting: "Creating...",
        successTitle: "Account verified successfully!",
        successDescription: "Your email has been verified and your account is now active. You can log in and navigate to the Affiliate page in the dashboard.",
        genericError: "An error occurred. Please try again.",
        verifyTitle: "Verify your email",
        verifyDescription: "We have sent a verification email to your address. Please enter the code from the email or click the link in the email to verify your account.",
        codeLabel: "Verification code",
        codePlaceholder: "123456",
        codeRequired: "Please enter the verification code.",
        verifyButton: "Verify",
        verifying: "Verifying...",
        verifyError: "Verification failed. Please check your code and try again.",
        verifyHint: "Didn't receive an email? Check your spam folder or go back to register again."
      }
    }
  },
  verifyRegistration: {
    title: "Verify Registration",
    subtitle: "Account Verification",
    verifying: "Verifying your account...",
    success: "Your account has been verified!",
    successDetail: "Your email has been confirmed and your account is now active. You can log in and start using Nextproptrader.",
    error: "Verification failed. The link may be invalid or expired.",
    tryCode: "Enter verification code manually instead",
    codeTitle: "Enter Verification Code",
    codeDescription: "Enter the verification code from the email we sent you to complete your registration.",
    emailLabel: "Email address",
    emailPlaceholder: "your@email.com",
    codeLabel: "Verification code",
    codePlaceholder: "123456",
    allFieldsRequired: "Please fill in all fields.",
    verifyButton: "Verify Account",
    verifyingButton: "Verifying...",
    backToHome: "Back to Homepage"
  },
  verifyPayment: {
    subtitle: "Payment Verification",
    verifying: "Verifying your payment...",
    verifyingDetail: "We are checking your payment status. This may take a few moments.",
    success: "Payment successful!",
    successDetail: "Your payment has been confirmed. Your account is being set up and will be available shortly.",
    failed: "Payment failed",
    failedDetail: "Your payment could not be processed. Please try again or contact support if the problem persists.",
    expired: "Payment link expired",
    expiredDetail: "This payment link has expired. Please start a new checkout to complete your purchase.",
    timeout: "Verification is taking longer than expected",
    timeoutDetail: "Your payment may still be processing. You can try again or check your email for a confirmation.",
    retry: "Check again",
    backToHome: "Back to Homepage",
    closeTab: "Close Tab"
  },
  whiteLabelModal: {
    title: "White Label Solution",
    subtitle: "Complete infrastructure and technology platform",
    heroTitle: "Launch Your Own Prop Trading Firm",
    heroDescription: "Get a fully branded, turnkey prop trading platform under your own name. Our white label solution provides everything you need to run a professional prop trading business — from trader evaluation to funded account management.",
    features: {
      customBranding: {
        title: "Custom Branding",
        description: "Full branding customization including logo, colors, fonts, and design elements to match your corporate identity."
      },
      ownDomain: {
        title: "Your Own Domain",
        description: "Run your platform on your own domain with custom SSL certificates for a seamless, professional experience."
      },
      fullControl: {
        title: "Full Control",
        description: "Manage traders, accounts, payouts, and rules independently with a powerful admin dashboard."
      },
      cloudHosting: {
        title: "Cloud Hosting",
        description: "Enterprise-grade cloud infrastructure with global CDN, automatic scaling, and 99.9% uptime guarantee."
      },
      apiAccess: {
        title: "API Access",
        description: "Comprehensive REST API for seamless integration with your existing systems and third-party services."
      },
      customization: {
        title: "Flexible Customization",
        description: "Configure evaluation rules, profit splits, account sizes, and trading parameters to fit your business model."
      }
    },
    whyChoose: {
      title: "Why White Label?",
      setup: {
        value: "< 2 Weeks",
        label: "Setup Time"
      },
      uptime: {
        value: "99.9%",
        label: "Uptime Guarantee"
      },
      support: {
        value: "24/7",
        label: "Technical Support"
      }
    },
    contact: {
      title: "Ready to Launch Your White Label Solution?",
      description: "Contact our team to discuss your white label requirements and get a custom solution tailored to your business needs.",
      button: "Contact White Label Team"
    }
  },
  affiliateStatus: {
    enroll: {
      title: "Join the Affiliate Program",
      subtitle: "Become a Nextproptrader Partner",
      description: "If you would like to participate in the Nextproptrader affiliate program, you can easily register here. By signing up, you confirm that you have read and accept our terms of service, privacy policy, and affiliate guidelines \u2013 participation is only possible after acceptance.",
      benefits: "As an affiliate, you will have access to a powerful partner dashboard with full tracking (clicks, leads, sales in real time), individual affiliate links, and the ability to create your own coupon codes. You benefit from generous commissions, optional bonus payments, and flexible payout options \u2013 including bank transfer, PayPal, or crypto (depending on availability/option in the system).",
      button: "Register Now",
      enrolling: "Registering...",
      trackingTitle: "Real-Time Tracking",
      trackingDesc: "Track clicks, leads & sales live",
      linksTitle: "Custom Links",
      linksDesc: "Individual affiliate links & coupon codes",
      commissionsTitle: "Commissions",
      commissionsDesc: "Generous compensation & bonus payments",
      payoutsTitle: "Flexible Payouts",
      payoutsDesc: "Bank, PayPal or Crypto"
    },
    suspended: {
      title: "Account Suspended",
      description: "Your affiliate account has been suspended. You no longer have access to the affiliate program.",
      support: "If you believe this is a mistake or would like more information, please contact our support team for clarification.",
      contactSupport: "Contact Support"
    },
    pending: {
      title: "Complete Affiliate Registration",
      subtitle: "Accept terms and set up your partner profile",
      step1: "Accept Terms",
      step2: "Partner Name",
      loading: "Loading Agreements",
      loadingDescription: "Preparing your affiliate registration...",
      termsTitle: "Affiliate Program Terms & Conditions",
      acceptTerms: "I have read and agree to the Affiliate Program Terms & Conditions",
      continue: "Continue to Step 2",
      nameTitle: "Set Your Partner Name",
      nameDescription: "Choose a display name that will be shown in your affiliate materials and reports",
      partnerName: "Partner Display Name",
      partnerNamePlaceholder: "Enter your partner name...",
      back: "Back",
      complete: "Complete Registration",
      submitting: "Completing..."
    },
    complete: {
      title: "Registration Complete",
      description: "Your affiliate account is being activated. This page will update automatically."
    }
  },
  months: {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
  },
  partnerLanding: {
    backToMainSite: "Back to Main Site",
    officialPartner: "Official Partner",
    heroDescription: "Get exclusive access to professional prop trading with special partner benefits. Start your funded trading journey with",
    profitSplit: "100% profit split",
    noHiddenFees: "and no hidden fees.",
    benefits: {
      exclusiveDiscounts: {
        title: "Exclusive Discounts",
        description: "Special pricing only available through {partner}"
      },
      profitSplit: {
        title: "100% Profit Split",
        description: "Keep everything you earn - no hidden cuts"
      },
      premiumSupport: {
        title: "Premium Support",
        description: "Priority support as a partner referral"
      }
    },
    startEvaluation: "Start Your Evaluation",
    whyChoose: "Why Choose",
    whyChooseBadge: "Our Advantages",
    recommendedBy: "Recommended by {partner} for serious traders who want real results",
    features: {
      profitSplit: {
        title: "100% Profit Split",
        description: "Keep everything you earn. No hidden cuts or fees."
      },
      dailyPayouts: {
        title: "Daily Payouts",
        description: "Access your profits immediately, not weeks later."
      },
      transparentRules: {
        title: "Transparent Rules",
        description: "Clear, fair rules with no surprise restrictions."
      },
      noTimePressure: {
        title: "No Time Pressure",
        description: "Trade at your own pace - no minimum trading days required."
      }
    },
    pricing: {
      exclusiveBadge: "EXCLUSIVE PARTNER PRICING",
      title: "Special Rates for",
      community: "Community",
      description: "Get exclusive discounts and start trading with our capital today. Limited time offer!"
    },
    testimonial: {
      title: "Trusted by",
      quote: "{partner} has carefully selected Nextproptrader as the preferred prop trading firm for our community. With their 100% profit split and transparent approach, they align perfectly with our values of helping traders succeed.",
      stats: {
        profitSplit: "Profit Split",
        daily: "Daily",
        payouts: "Payouts",
        oneDay: "5 Days",
        minEvaluation: "Min. Evaluation"
      }
    },
    howItWorks: {
      badge: "How It Works",
      title: "How It",
      titleHighlight: "Works",
      subtitle: "Simple 3-step process to get funded and start earning",
      steps: {
        step1: {
          title: "Choose Your Plan",
          description: "Select the account size that fits your trading style and get exclusive partner discounts."
        },
        step2: {
          title: "Pass Evaluation",
          description: "Hit your profit target while managing risk properly - no time pressure."
        },
        step3: {
          title: "Get Funded & Paid",
          description: "Receive your funded account and start earning with 100% profit split and daily payouts."
        }
      }
    },
    finalCta: {
      title: "Ready to Start Trading with",
      titleHighlight: "Our Capital?",
      description: "Join thousands of successful traders who trust Nextproptrader. Get started today with exclusive {partner} pricing.",
      viewPricing: "View Partner Pricing",
      learnMore: "Learn More About Nextproptrader"
    }
  },
  kyc: {
    title: "Identity Verification",
    subtitle: "KYC Verification",
    introTitle: "Verify Your Identity",
    introDescription: "Before you can request a payout, we need to verify your identity. This is a one-time process required by regulatory standards to ensure the security of your account and funds.",
    introStep1: "Provide your date of birth",
    introStep2: "Confirm your nationality and country of residence",
    introStep3: "Upload a valid government-issued ID document",
    introNote: "Your data is encrypted and stored securely. We only use it for verification purposes in compliance with applicable regulations.",
    startVerification: "Start Verification",
    stepPersonal: "Personal Info",
    stepDocument: "Document",
    stepReview: "Review",
    personalInfoTitle: "Personal Information",
    personalInfoDesc: "Please provide your personal details exactly as they appear on your official ID document.",
    dateOfBirth: "Date of Birth",
    nationality: "Nationality",
    residenceCountry: "Country of Residence",
    searchCountry: "Search country...",
    continue: "Continue",
    documentTitle: "Identity Document",
    documentDesc: "Upload a clear photo or scan of your government-issued identification document.",
    acceptedDocuments: "Accepted Documents",
    docPassport: "Valid passport",
    docIdCard: "National ID card",
    docRequirements: "JPG, PNG, WebP or PDF. Max 10 MB. Ensure the document is clearly visible and all details are readable.",
    dragOrClick: "Click to upload or drag and drop",
    supportedFormats: "JPG, PNG, WebP, PDF - max 10 MB",
    clickToChange: "Click to change file",
    uploadDocument: "Upload & Continue",
    back: "Back",
    reviewTitle: "Review Your Information",
    reviewDesc: "Please verify that all information is correct before submitting.",
    documentUploaded: "Document",
    documentReady: "Document uploaded",
    reviewWarning: "Please ensure all information matches your official documents exactly. Incorrect information may delay the verification process.",
    submitVerification: "Submit Verification",
    successTitle: "Verification Submitted",
    successDescription: "Your identity verification has been submitted successfully. Our team will review your documents and you will be notified once the process is complete.",
    processingTime: "Processing time: up to 48 hours",
    pendingTitle: "Verification In Progress",
    pendingDescription: "Your identity verification is currently being reviewed by our team. You will be notified once the review is complete. This usually takes up to 48 hours.",
    close: "Close",
    errorStarting: "Failed to start verification. Please try again.",
    errorSaving: "Failed to save your information. Please try again.",
    errorSubmitting: "Failed to submit verification. Please try again.",
    uploadFailed: "Failed to upload document. Please try again.",
    invalidFileType: "Invalid file type. Please upload a JPG, PNG, WebP or PDF file.",
    fileTooLarge: "File is too large. Maximum size is 10 MB.",
    rejectedTitle: "Verification Rejected",
    rejectedDescription: "Unfortunately, your identity verification has been rejected. Please review the reason below and restart the process with correct information.",
    rejectionReasonLabel: "Reason for rejection",
    rejectedHint: "You can restart the verification process. Please ensure all information is correct and your documents are clearly readable.",
    restartVerification: "Restart Verification"
  },
  countdown: {
    comingSoon: "Coming Soon",
    liveNow: "We Are Live",
    description: "Something big is on its way. Get ready for a new era of prop trading.",
    liveDescription: "The wait is over. Welcome to the future of prop trading.",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    launchDate: "April 1, 2026 - 08:00 UTC",
    enterCode: "Access code..."
  },
  affiliatePage: {
    nav: {
      home: "Home",
      apply: "Apply for Free"
    },
    hero: {
      badge: "NEXTPROPTRADER AFFILIATE PROGRAM",
      headline: "Earn with every trader you refer.",
      subline: "Become an affiliate partner of Nextproptrader and build a scalable income with a strong product, attractive commissions, and bonus tiers.",
      cta1: "Apply for Free",
      cta2: "Calculate Your Affiliate Potential",
      trust1: "25% Affiliate Commission",
      trust2: "Best Conditions",
      trust3: "100% Payout for Your Community",
      trust4: "Unique Bonuses",
      dashboardTitle: "Affiliate Dashboard",
      dashboardLive: "Live",
      dashboardClicks: "Clicks",
      dashboardOrders: "Orders",
      dashboardConversion: "Conversion",
      dashboardCommission: "Total Commission",
      dashboardTier: "Current Tier",
      dashboardRecentSales: "Recent Sales"
    },
    stats: {
      funded: "Funded Capital",
      traders: "Active Traders",
      commission: "Affiliate Commission",
      bonus: "One-Time Bonus Possible"
    },
    why: {
      headline: "Why promote Nextproptrader?",
      cards: [
        {
          title: "A Product Traders Trust",
          text: "Nextproptrader offers 100% profit share, daily payouts, and fair evaluations — a proposition that stands out in the prop trading industry."
        },
        {
          title: "Competitive Commission Structure",
          text: "Start at 10% and grow to 25% commission per sale. Every referral pays out directly — with no volume caps."
        },
        {
          title: "One-Time Milestone Bonuses",
          text: "Reaching key milestones unlocks one-time cash bonuses — up to €10,000 per tier."
        },
        {
          title: "Transparent Live Dashboard",
          text: "Track clicks, conversions, and your commission in real time. Full visibility into your performance — anytime, anywhere."
        }
      ]
    },
    tiers: {
      headline: "Your Path. Your Commission.",
      subline: "Start as an affiliate and progress step by step into higher commission tiers.",
      commissionLabel: "Commission",
      bonusLabel: "One-Time Bonus",
      salesLabel: "from Sales",
      overviewLabel: "Tier Overview",
      startLevel: "Starting Level",
      fromSales: "from {n} Sales",
      tierOf: "Tier {current} / {total}",
      noMinimum: "No Minimum",
      noMinRevenue: "No minimum revenue",
      confirmedSales: "From {n} confirmed sales",
      maxCommission: "Max. Commission",
      descriptions: {
        starter: "Perfect for getting started. Begin with no minimum requirements and earn immediately from your first referrals. No application, no minimum revenue.",
        bronze: "Your first milestone. With 50 successful sales you unlock a one-time bonus and prove that your audience converts.",
        silber: "Solid performance. At 150 sales your bonus grows to €2,500 — a clear signal that your channel delivers real value.",
        gold: "Higher commission. From 300 sales your commission rises to 15% — more earnings on the same referrals, automatically.",
        platin: "Strong reach. 500 sales mean a proven referral model — rewarded with a one-time bonus of €5,000.",
        diamant: "Top performance. You have built a scalable affiliate machine. Your one-time bonus: €10,000.",
        elite: "Elite status. Only the strongest affiliates reach this tier — with 25% commission on every sale and unlimited potential."
      }
    },
    calc: {
      headline: "Calculate Your Affiliate Potential",
      subline: "Get a rough estimate of how much commission your reach could generate.",
      disclaimer: "This calculation is an estimate only and is based on assumptions about conversion rate and average order value.",
      followerLabel: "Your Subscribers / Followers",
      conversionLabel: "Estimated Conversion Rate",
      salesOutput: "Estimated Sales",
      revenueOutput: "Estimated Revenue",
      commissionOutput: "Estimated Commission",
      tierOutput: "Current Tier",
      progressLabel: "Sales until next tier",
      bonusNote: "Reaching this tier also includes a one-time bonus of",
      bonusNote2: "",
      cta: "Apply for Free",
      basisLabel: "Calculation Basis",
      estimatedBuyers: "Estimated Buyers",
      avgOrderValue: "Avg. Order Value",
      commissionShort: "Commission",
      perMonthEstimate: "per month (estimate)",
      footerNote: "Estimate based on historical averages. Individual results may vary.",
      eliteReached: "Elite status reached",
      eliteMax: "Maximum commission of 25%"
    },
    steps: {
      headline: "How It Works",
      items: [
        {
          title: "Register for Free",
          text: "Apply to the affiliate program and get instant access to your personal tracking link upon approval."
        },
        {
          title: "Share Your Affiliate Link",
          text: "Embed your link in videos, newsletters, social posts, or your website — and reach your audience wherever they are active."
        },
        {
          title: "Earn Commission",
          text: "For every successful purchase through your link, you receive your commission. As performance grows, you automatically advance to higher tiers."
        }
      ]
    },
    faq: {
      headline: "Frequently Asked Questions",
      items: [
        {
          q: "How high is the commission?",
          a: "Commission starts at 10% (Starter tier) and can rise to 25% (Elite tier) as your performance grows. Certain tiers also include one-time bonuses of up to €10,000."
        },
        {
          q: "When do I get paid?",
          a: "Exact payout details are communicated during onboarding. We are building a transparent and reliable payout process for all affiliate partners."
        },
        {
          q: "Are there minimum requirements?",
          a: "There are no minimum follower counts or revenue thresholds to apply. Anyone with a relevant trading or finance audience is welcome to apply."
        },
        {
          q: "How long is the cookie valid?",
          a: "The tracking cookie duration is communicated within the affiliate dashboard. A longer cookie window generally enables higher conversion rates for your referrals."
        },
        {
          q: "Can I create multiple links?",
          a: "Yes. Inside the affiliate dashboard you can create multiple tracking links for different channels, campaigns, or content pieces, and track their performance separately."
        }
      ]
    },
    cta: {
      headline: "Ready to grow as a Nextproptrader affiliate?",
      subline: "Apply for free and secure your access to the affiliate program.",
      button: "Apply for Free",
      support: "Free. Non-binding. Quick start."
    },
    footer: {
      copy: "© 2024 Nextproptrader. All rights reserved.",
      program: "Affiliate Program"
    }
  }
};